var _style, _circle, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingVariant2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 421,
    viewBox: "0 0 313 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    #person {\n      transform: translateX(-8px);\n    }\n    #bubble-1 {\n      opacity: 0;\n      transform: scale(0);\n      animation: thinkingBubble 150ms ease-out forwards;;\n      animation-delay: 500ms;\n    }\n    #bubble-2 {\n      opacity: 0;\n      transform: scale(0);\n      animation: thinkingBubble 150ms ease-out forwards;;\n      animation-delay: 1300ms;\n    }\n    #bubble-3 {\n      opacity: 0;\n      transform: scale(0);\n      animation: thinkingBubble 150ms ease-out forwards;;\n      animation-delay: 2100ms;\n    }\n    @keyframes thinkingBubble {\n      0% { transform: scale(0); opacity: 0; }\n      90% { transform: scale(1.1); opacity: 0.1; }\n      100% { transform: scale(1); opacity: 1; }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "Loader 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58_978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 129,
    width: 292,
    height: 292
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 167,
    cy: 275,
    r: 146,
    fill: "#F2FAF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58_978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 47",
    x: -11,
    y: 125,
    width: 360,
    height: 322,
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Man2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M123.221 408.071C123.284 410.854 123.504 413.542 123.866 416.058C125.061 424.484 127.875 430.961 132.151 432.25C149.413 437.438 205.254 431.103 213.319 428.792C217.186 427.691 219.12 424.861 220.331 421.277C221.321 418.337 221.793 414.863 222.422 411.42C222.626 410.304 222.846 409.172 223.098 408.071L140.782 385.905C140.782 385.905 127.733 393.278 124.133 402.962C123.52 404.597 123.174 406.311 123.221 408.071Z",
    fill: "#F7C29A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M143.36 389.929L148.249 394.535C148.249 394.535 184.565 419.972 220.299 421.277C221.29 418.337 221.761 414.863 222.39 411.42C219.293 410.602 217.029 410.068 217.029 410.068L143.36 389.929Z",
    fill: "#C98A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M123.221 408.071C123.284 410.854 123.504 413.542 123.866 416.058C133.409 415.209 144.696 403.748 148.265 394.551H143.376L124.118 402.962C123.52 404.597 123.174 406.311 123.221 408.071Z",
    fill: "#C98A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M173.01 281.139C173.01 281.139 224.528 290.635 236.335 296.389C248.141 302.142 248.707 316.543 248.424 325.74C248.141 334.952 241.806 394.52 236.335 404.314C230.864 414.092 222.233 414.957 212.737 413.243C203.242 411.514 158.924 400.572 148.265 394.535C140.2 403.166 129.557 411.231 121.492 412.096C113.427 412.96 102.784 390.511 99.0424 380.732C95.3008 370.954 84.9406 342.451 86.0882 328.35C87.2359 314.248 107.673 304.17 116.304 298.417C124.935 292.663 150.843 281.155 150.843 281.155H173.01V281.139Z",
    fill: "#F7C29A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M156.283 380.669L206.323 386.848L216.259 324.687C216.149 324.121 215.363 324.105 215.221 324.655L201.355 383.185L157.069 379.16C156.802 379.648 156.55 380.166 156.283 380.669Z",
    fill: "#C98A5A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M148.265 394.928C148.187 394.928 148.108 394.913 148.045 394.866C147.872 394.74 147.825 394.504 147.951 394.331C150.309 390.872 153.013 386.219 155.953 380.496C156.204 379.993 156.472 379.49 156.739 378.971C158.059 376.377 159.16 374.302 160.119 372.447C164.442 364.225 166.219 360.814 174.236 338.82C174.315 338.615 174.535 338.521 174.724 338.584C174.928 338.663 175.022 338.883 174.96 339.071C166.926 361.112 165.134 364.539 160.795 372.793C159.836 374.632 158.735 376.723 157.415 379.302C157.148 379.82 156.896 380.323 156.629 380.827C153.658 386.58 150.953 391.25 148.58 394.74C148.501 394.865 148.375 394.928 148.265 394.928Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M120.627 377.792C120.533 377.792 120.439 377.761 120.36 377.682C120.203 377.541 120.187 377.289 120.344 377.132C120.376 377.101 120.407 377.069 120.439 377.038C121.429 375.937 122.514 374.68 123.662 373.296C123.976 372.919 124.29 372.526 124.621 372.117C125.265 371.315 125.784 370.655 126.271 370.026C126.649 369.539 127.042 369.036 127.435 368.517C128.001 367.778 128.567 367.023 129.148 366.253L129.274 366.08C129.416 365.891 129.557 365.687 129.699 365.498C130.626 364.256 131.585 362.936 132.56 361.568C143.502 346.303 154.585 328.302 154.695 328.114C154.805 327.925 155.041 327.878 155.23 327.988C155.418 328.098 155.465 328.334 155.355 328.522C155.245 328.695 144.162 346.727 133.189 362.024C132.198 363.392 131.239 364.712 130.312 365.97C130.17 366.159 130.029 366.363 129.887 366.552L129.761 366.725C129.18 367.495 128.614 368.25 128.048 368.989C127.655 369.492 127.262 369.995 126.884 370.498C126.397 371.127 125.863 371.787 125.218 372.589C124.888 372.997 124.573 373.39 124.259 373.768C123.111 375.167 122.011 376.44 121.02 377.541C120.989 377.572 120.958 377.619 120.91 377.651C120.832 377.761 120.738 377.792 120.627 377.792Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M178.041 339.952C178.009 339.952 177.978 339.952 177.947 339.936C164.961 336.855 154.868 328.711 154.774 328.633C154.616 328.507 154.585 328.302 154.695 328.13L163.184 314.311C163.295 314.138 163.499 314.075 163.688 314.169L183.056 323.885C183.229 323.963 183.307 324.168 183.245 324.341C183.213 324.419 180.682 332.704 178.403 339.669C178.355 339.842 178.214 339.952 178.041 339.952ZM155.528 328.255C157.179 329.529 166.297 336.305 177.789 339.119C179.786 332.987 181.94 325.991 182.427 324.451L163.656 315.05L155.528 328.255Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M175.101 333.758C173.891 333.758 172.916 332.783 172.916 331.572C172.916 330.362 173.891 329.387 175.101 329.387C176.312 329.387 177.286 330.362 177.286 331.572C177.286 332.783 176.296 333.758 175.101 333.758ZM175.101 330.158C174.315 330.158 173.686 330.786 173.686 331.572C173.686 332.358 174.315 332.987 175.101 332.987C175.887 332.987 176.516 332.358 176.516 331.572C176.516 330.786 175.871 330.158 175.101 330.158Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M217.784 392.224C216.322 392.224 214.797 391.8 213.209 390.967C211.747 390.181 210.426 389.159 209.153 388.168C208.98 388.043 208.949 387.791 209.09 387.634C209.216 387.461 209.467 387.43 209.625 387.571C210.867 388.546 212.156 389.552 213.571 390.307C215.127 391.14 216.636 391.533 218.035 391.47C218.256 391.454 218.994 391.407 219.136 390.983C219.277 390.542 218.68 390.039 218.413 389.851C215.331 387.618 211.15 386.502 206.653 386.691C206.433 386.706 206.26 386.533 206.245 386.329C206.229 386.109 206.402 385.936 206.606 385.92C211.275 385.716 215.614 386.879 218.837 389.222C219.702 389.851 220.063 390.558 219.843 391.218C219.639 391.831 218.979 392.193 218.051 392.24C217.973 392.224 217.878 392.224 217.784 392.224Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M210.804 399.22C210.301 399.22 209.782 398.984 209.373 398.576C208.964 398.151 208.713 397.632 208.508 397.177C207.031 393.765 206.528 390.055 206.025 386.47C205.993 386.266 206.15 386.062 206.355 386.03C206.559 385.999 206.763 386.156 206.795 386.36C207.282 389.898 207.785 393.545 209.216 396.862C209.389 397.255 209.593 397.711 209.908 398.025C210.206 398.324 210.599 398.481 210.93 398.434C211.228 398.387 211.511 398.151 211.7 397.821C211.857 397.538 211.951 397.161 211.999 396.658C212.109 395.321 211.841 393.875 211.212 392.35C210.615 390.935 209.766 389.63 208.949 388.451C208.823 388.278 208.87 388.043 209.043 387.917C209.216 387.791 209.452 387.838 209.578 388.011C210.426 389.237 211.291 390.574 211.92 392.051C212.612 393.686 212.895 395.243 212.769 396.721C212.737 397.114 212.659 397.68 212.376 398.183C212.077 398.717 211.59 399.094 211.055 399.173C210.977 399.22 210.898 399.22 210.804 399.22Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M173.042 357.717C171.973 357.717 171.108 356.852 171.108 355.783C171.108 354.714 171.973 353.849 173.042 353.849C174.111 353.849 174.975 354.714 174.975 355.783C174.975 356.852 174.111 357.717 173.042 357.717ZM173.042 354.635C172.397 354.635 171.878 355.154 171.878 355.799C171.878 356.443 172.397 356.962 173.042 356.962C173.686 356.962 174.205 356.443 174.205 355.799C174.205 355.154 173.686 354.635 173.042 354.635Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M173.042 375.56C171.973 375.56 171.108 374.695 171.108 373.626C171.108 372.557 171.973 371.693 173.042 371.693C174.111 371.693 174.975 372.557 174.975 373.626C174.975 374.695 174.111 375.56 173.042 375.56ZM173.042 372.479C172.397 372.479 171.878 372.997 171.878 373.642C171.878 374.287 172.397 374.805 173.042 374.805C173.686 374.805 174.205 374.287 174.205 373.642C174.205 372.997 173.686 372.479 173.042 372.479Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M166.722 380.402C166.502 380.402 166.344 380.229 166.344 380.025V359.587C166.344 359.367 166.517 359.21 166.722 359.21C166.926 359.21 167.099 359.383 167.099 359.587V380.025C167.099 380.229 166.926 380.402 166.722 380.402Z",
    fill: "#C98A5A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M130.579 360.735L114.339 332.531C114.229 332.327 113.915 332.484 114.009 332.689L127.152 363.172L130.579 360.735Z",
    fill: "#C98A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M112.295 359.745C112.704 360.295 113.349 360.688 114.04 360.971C114.968 361.364 116.005 361.6 116.854 361.898C118.615 362.543 120.376 363.188 122.137 363.832C124.573 364.728 127.01 365.609 129.463 366.505C129.651 366.253 129.84 366.002 130.029 365.75C130.988 364.461 131.947 363.156 132.89 361.82C129.997 360.436 127.057 359.147 123.992 358.283C120.077 357.182 115.895 356.758 111.918 357.685C111.729 358.345 111.871 359.194 112.295 359.745Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M107.202 363.706C108.019 364.712 109.56 365.058 110.896 365.388C111.226 365.467 111.541 365.561 111.839 365.64C113.632 366.206 115.408 366.756 117.2 367.322C120.313 368.297 123.442 369.272 126.554 370.262C126.932 369.775 127.325 369.272 127.718 368.753C128.284 368.014 128.85 367.259 129.431 366.489C129.62 366.237 129.809 365.986 129.997 365.734C126.35 364.131 122.656 362.59 118.788 361.678C117.232 361.317 115.628 361.065 114.04 360.955C111.572 360.782 109.088 360.971 106.714 361.631C106.573 362.339 106.761 363.172 107.202 363.706Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M108.066 368.077C109.088 369.334 111.226 369.555 112.72 370.026C113.679 370.325 114.653 370.639 115.628 370.938C116.446 371.19 117.263 371.457 118.081 371.708C120.046 372.321 122.011 372.935 123.96 373.548C124.275 373.17 124.605 372.777 124.919 372.369C125.47 371.693 126.02 370.985 126.57 370.278C126.947 369.79 127.34 369.287 127.733 368.769C125.108 367.684 122.42 366.709 119.653 366.065C116.792 365.404 113.805 365.106 110.896 365.404C109.764 365.514 108.664 365.719 107.563 366.033C107.438 366.709 107.626 367.542 108.066 368.077Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M110.88 373.721C111.902 374.978 114.04 375.199 115.534 375.67C117.279 376.22 119.008 376.755 120.738 377.305C121.775 376.173 122.844 374.916 123.96 373.548C124.275 373.17 124.605 372.777 124.919 372.369C124.118 372.117 123.3 371.897 122.467 371.708C120.219 371.19 117.908 370.891 115.612 370.938C113.852 370.97 112.091 371.19 110.377 371.677C110.252 372.353 110.44 373.186 110.88 373.721Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M181.075 275.574L150.702 266.943L150.167 278.262L164.285 292.82L173.875 292.175L181.075 275.574Z",
    fill: "#963E31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M150.167 278.262L138.911 286.626L154.491 307.047L165.904 290.446L150.167 278.262Z",
    fill: "#F7C29A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M154.491 307.425C154.365 307.425 154.255 307.362 154.192 307.267L138.612 286.846C138.55 286.767 138.518 286.657 138.534 286.563C138.55 286.468 138.597 286.374 138.691 286.311L149.947 277.948C150.089 277.838 150.277 277.853 150.419 277.948L166.156 290.131C166.313 290.257 166.36 290.493 166.234 290.65L154.821 307.252C154.742 307.362 154.632 307.425 154.491 307.425C154.506 307.425 154.491 307.425 154.491 307.425ZM139.461 286.704L154.475 306.387L165.385 290.524L150.167 278.734L139.461 286.704Z",
    fill: "#C98A5A"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M191.325 203.335C191.655 202.769 192.159 202.345 192.724 202.046C192.284 202.502 191.813 202.927 191.325 203.335Z",
    fill: "#5F173C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M174.598 197.77C174.519 197.77 174.441 197.739 174.378 197.691C174.221 197.566 174.174 197.346 174.284 197.173C174.488 196.858 174.708 196.544 174.991 196.167C175.117 196.009 175.337 195.962 175.51 196.072C175.683 196.182 175.73 196.418 175.636 196.591C175.29 197.188 174.928 197.613 174.912 197.629C174.818 197.723 174.708 197.77 174.598 197.77Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M144.759 244.619C145.042 236.161 143.91 227.986 143.062 219.544C156.314 213.633 171.249 213.9 185.336 214.749C185.902 222.924 187.301 230.816 189.847 238.708C190.288 240.248 191.938 240.248 193.573 240.028C194.249 249.194 194.737 257.495 194.737 259.413C194.737 263.296 180.635 278.545 177.035 281.139C173.435 283.733 165.496 284.613 162.933 284.189C160.37 283.764 148.973 273.074 146.237 269.914C144.995 268.468 142.763 258.312 140.578 246.82C142.055 247.622 144.492 246.977 144.759 244.619Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M151.142 202.424C158.767 203.147 162.839 200.977 165.92 197.094C168.986 193.211 171.297 192.629 174.457 193.211C176.547 193.588 175.934 195.286 175.29 196.402C175.054 196.717 174.818 197.047 174.598 197.393C174.598 197.393 174.944 196.984 175.29 196.402C178.072 192.676 182.569 190.287 187.222 190.02C189.989 189.862 193.086 190.633 194.58 192.959C195.649 194.626 195.664 196.827 194.957 198.682C194.47 199.94 193.683 201.056 192.74 202.031C192.174 202.314 191.687 202.754 191.341 203.32C191.828 202.927 192.3 202.486 192.74 202.031C193.888 201.449 195.381 201.417 196.576 202.015C198.368 202.895 199.422 204.955 199.359 206.951C199.296 208.948 198.243 210.834 196.749 212.155C195.256 213.491 193.086 214.419 191.152 214.938C191.954 220.126 192.866 230.533 193.573 240.028C191.938 240.233 190.288 240.249 189.848 238.708C187.599 231.728 186.247 224.748 185.571 217.563C185.414 215.944 184.094 214.686 182.474 214.592C170.07 213.947 157.148 214.01 145.404 218.569C144.021 219.104 143.172 220.519 143.329 221.981C144.131 229.574 145.027 236.979 144.775 244.619C144.508 246.961 142.087 247.622 140.609 246.804C137.952 233.017 135.374 217.296 134.588 212.359C133.142 203.288 143.502 201.7 151.142 202.424Z",
    fill: "#5F173C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M201.99 250.199C204.069 246.083 203.053 241.383 199.72 239.699C196.388 238.016 192.001 239.987 189.922 244.102C187.843 248.218 188.86 252.918 192.192 254.602C195.525 256.285 199.911 254.314 201.99 250.199Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M144.622 260.388C147.617 258.161 147.816 253.356 145.065 249.656C142.314 245.957 137.655 244.764 134.659 246.992C131.663 249.22 131.465 254.024 134.216 257.724C136.967 261.423 141.626 262.616 144.622 260.388Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M169.583 260.434C169.41 260.434 169.253 260.324 169.206 260.151C169.143 259.947 169.269 259.727 169.473 259.68C171.312 259.161 173.073 258.265 174.582 257.102C175.243 256.599 175.526 256.174 175.51 255.75C175.478 255.168 174.818 254.712 174.236 254.319C171.155 252.212 168.828 248.942 167.869 245.342C167.822 245.138 167.932 244.933 168.137 244.871C168.341 244.823 168.545 244.933 168.608 245.138C169.52 248.565 171.721 251.678 174.661 253.69C175.353 254.162 176.217 254.759 176.264 255.734C176.296 256.63 175.588 257.306 175.038 257.73C173.45 258.957 171.595 259.9 169.662 260.434C169.646 260.434 169.614 260.434 169.583 260.434Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M172.979 268.672C169.174 268.672 165.37 267.729 162.037 265.921C161.848 265.827 161.785 265.591 161.88 265.402C161.974 265.214 162.21 265.151 162.398 265.245C167.083 267.792 172.759 268.547 177.962 267.32C178.167 267.273 178.371 267.399 178.418 267.603C178.465 267.808 178.34 268.012 178.135 268.059C176.453 268.484 174.724 268.672 172.979 268.672Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M171.438 271.848C170.589 271.848 169.756 271.691 168.97 271.392C168.765 271.313 168.671 271.093 168.75 270.889C168.828 270.685 169.048 270.59 169.253 270.669C170.809 271.266 172.633 271.188 174.126 270.465C174.315 270.37 174.551 270.449 174.645 270.637C174.739 270.826 174.661 271.062 174.472 271.156C173.529 271.612 172.491 271.848 171.438 271.848Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M160.198 267.352C160.103 267.352 160.009 267.32 159.93 267.242C159.773 267.1 159.773 266.849 159.915 266.691C161.125 265.434 162.729 264.538 164.426 264.192C164.631 264.145 164.835 264.286 164.882 264.49C164.93 264.695 164.788 264.899 164.584 264.946C163.027 265.261 161.565 266.078 160.465 267.226C160.402 267.304 160.292 267.352 160.198 267.352Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M159.05 250.782C159.962 250.782 160.701 249.543 160.701 248.015C160.701 246.487 159.962 245.248 159.05 245.248C158.138 245.248 157.399 246.487 157.399 248.015C157.399 249.543 158.138 250.782 159.05 250.782Z",
    fill: "#400F28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M180.21 249.052C181.122 249.052 181.861 247.814 181.861 246.285C181.861 244.757 181.122 243.519 180.21 243.519C179.299 243.519 178.56 244.757 178.56 246.285C178.56 247.814 179.299 249.052 180.21 249.052Z",
    fill: "#400F28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M156.713 239.785C159.551 239.189 161.644 237.714 161.387 236.49C161.129 235.267 158.62 234.758 155.783 235.355C152.945 235.951 150.852 237.426 151.11 238.649C151.367 239.873 153.876 240.382 156.713 239.785Z",
    fill: "#5F173C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M185.443 236.308C185.519 235.06 183.235 233.904 180.341 233.726C177.446 233.548 175.038 234.416 174.961 235.664C174.884 236.911 177.168 238.067 180.063 238.245C182.957 238.423 185.366 237.556 185.443 236.308Z",
    fill: "#5F173C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M195.491 301.105C194.171 303.29 192.787 305.444 191.357 307.566C190.382 309.013 189.376 310.475 188.165 311.732C186.876 313.069 185.493 313.666 183.968 314.594C182.286 315.615 181.342 318.052 180.399 319.719C179.928 320.568 179.456 321.432 179 322.297L164.316 314.939C165.134 312.613 165.574 309.987 165.779 307.613C163.546 304.139 162.005 300.225 161.251 296.168C160.874 294.172 160.842 292.27 160.056 290.383C159.301 288.559 158.327 286.814 157.179 285.227C156.141 283.796 152.447 280.95 153.296 278.812C153.563 278.168 154.145 278.199 154.852 278.121C156.44 277.963 158.059 278.199 159.522 278.844C161.471 279.709 163.09 281.233 164.348 282.947C165.621 284.661 166.58 286.594 167.524 288.512C174.755 280.95 181.956 272.823 188.118 264.349C189.517 262.431 190.445 260.623 192.127 258.941C192.677 258.391 193.275 257.856 193.998 257.51C195.963 256.583 197.74 257.699 197.519 259.821C197.095 263.783 191.813 270.024 189.392 273.845C190.822 274.285 192.033 275.81 192.536 277.209C193.039 278.608 192.85 280.243 192.033 281.501C193.778 282.192 195.177 283.985 195.57 285.824C195.963 287.663 195.381 289.676 194.076 291.012C195.523 291.625 196.812 293.15 197.299 294.644C198.133 297.175 196.749 299.03 195.491 301.105Z",
    fill: "#C35D4E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M183.952 281.532C183.873 281.532 183.795 281.501 183.716 281.454C183.543 281.328 183.512 281.092 183.638 280.919L189.093 273.609C189.219 273.436 189.454 273.404 189.627 273.53C189.8 273.656 189.832 273.892 189.706 274.065L184.251 281.375C184.172 281.469 184.062 281.532 183.952 281.532Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M188.841 286.516C188.763 286.516 188.684 286.5 188.621 286.453C188.448 286.327 188.401 286.091 188.527 285.918L191.734 281.281C191.86 281.108 192.096 281.061 192.269 281.186C192.441 281.312 192.489 281.548 192.363 281.721L189.156 286.359C189.077 286.453 188.967 286.516 188.841 286.516Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M130.312 365.043C130.264 365.043 130.202 365.027 130.154 365.011C125.061 362.779 119.653 361.474 114.103 361.175C113.883 361.16 113.726 360.987 113.742 360.766C113.757 360.562 113.946 360.389 114.15 360.405C119.794 360.719 125.297 362.04 130.469 364.304C130.658 364.382 130.752 364.618 130.673 364.807C130.595 364.948 130.453 365.043 130.312 365.043Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M127.529 368.706C127.466 368.706 127.419 368.69 127.356 368.658C122.31 366.159 116.446 365.121 110.849 365.75C110.645 365.766 110.44 365.624 110.424 365.404C110.409 365.2 110.55 364.995 110.77 364.98C116.509 364.335 122.53 365.404 127.702 367.967C127.891 368.061 127.969 368.297 127.875 368.486C127.812 368.627 127.671 368.706 127.529 368.706Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M124.668 373.076C124.621 373.076 124.589 373.076 124.542 373.06C121.586 372.023 118.505 371.441 115.377 371.347C115.157 371.347 114.999 371.158 114.999 370.954C114.999 370.749 115.172 370.576 115.377 370.576H115.392C118.599 370.671 121.759 371.268 124.778 372.321C124.982 372.384 125.077 372.604 125.014 372.809C124.982 372.982 124.825 373.076 124.668 373.076Z",
    fill: "#7A2D20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M167.539 288.858C167.524 288.858 167.508 288.858 167.476 288.858C167.351 288.842 167.241 288.764 167.193 288.654C166.266 286.783 165.307 284.849 164.049 283.151C162.65 281.265 161.078 279.929 159.38 279.174C157.997 278.561 156.44 278.325 154.899 278.482C154.805 278.498 154.727 278.498 154.648 278.498C154.019 278.545 153.799 278.592 153.673 278.922C153.595 279.127 153.375 279.221 153.17 279.143C152.966 279.064 152.871 278.844 152.95 278.639C153.264 277.853 153.956 277.791 154.569 277.743C154.648 277.743 154.727 277.728 154.821 277.728C156.487 277.555 158.169 277.822 159.679 278.482C161.518 279.284 163.2 280.715 164.662 282.711C165.841 284.315 166.769 286.091 167.634 287.836C175.903 279.158 182.506 271.392 187.819 264.113C188.26 263.516 188.653 262.903 189.046 262.337C189.895 261.048 190.696 259.837 191.876 258.674C192.41 258.139 193.055 257.542 193.841 257.164C194.124 257.039 194.407 256.929 194.674 256.881C194.878 256.834 195.083 256.96 195.13 257.18C195.177 257.385 195.051 257.589 194.831 257.636C194.611 257.683 194.375 257.762 194.155 257.872C193.463 258.202 192.882 258.737 192.394 259.224C191.278 260.34 190.492 261.519 189.675 262.777C189.282 263.359 188.889 263.972 188.433 264.585C183.025 272.005 176.28 279.913 167.807 288.78C167.744 288.827 167.634 288.858 167.539 288.858Z",
    fill: "#7A2D20"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bubble-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-46-outside-1_58_978",
    maskUnits: "userSpaceOnUse",
    x: 169.547,
    y: 160.037,
    width: 25.5164,
    height: 25.4052,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 169.547,
    y: 160.037,
    width: 25.5164,
    height: 25.4052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.509 174.568C191.337 169.895 188.171 165.443 183.437 164.626C178.703 163.808 174.194 166.934 173.366 171.608C172.538 176.281 175.705 180.732 180.438 181.55C185.172 182.367 189.681 179.241 190.509 174.568Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.509 174.568C191.337 169.895 188.171 165.443 183.437 164.626C178.703 163.808 174.194 166.934 173.366 171.608C172.538 176.281 175.705 180.732 180.438 181.55C185.172 182.367 189.681 179.241 190.509 174.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.509 174.568C191.337 169.895 188.171 165.443 183.437 164.626C178.703 163.808 174.194 166.934 173.366 171.608C172.538 176.281 175.705 180.732 180.438 181.55C185.172 182.367 189.681 179.241 190.509 174.568Z",
    stroke: "#CAD5DD",
    strokeWidth: 4,
    mask: "url(#path-46-outside-1_58_978)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bubble-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-47-outside-2_58_978",
    maskUnits: "userSpaceOnUse",
    x: 184.112,
    y: 125.179,
    width: 35,
    height: 33,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 184.112,
    y: 125.179,
    width: 35,
    height: 33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.648 132.266C197.416 132.997 184.178 129.159 186.353 144.376C188.483 159.592 212.922 158.953 216.209 141.542C219.449 124.132 199.962 124.544 197.648 132.266Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.648 132.266C197.416 132.997 184.178 129.159 186.353 144.376C188.483 159.592 212.922 158.953 216.209 141.542C219.449 124.132 199.962 124.544 197.648 132.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.648 132.266C197.416 132.997 184.178 129.159 186.353 144.376C188.483 159.592 212.922 158.953 216.209 141.542C219.449 124.132 199.962 124.544 197.648 132.266Z",
    stroke: "#CAD5DD",
    strokeWidth: 4,
    mask: "url(#path-47-outside-2_58_978)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bubble-3"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-48-outside-3_58_978",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 235,
    height: 152,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 235,
    height: 152
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.32 28.3196C149.32 28.3196 97.1998 -17.879 34.295 19.7745C-12.7332 47.9688 -6.20666 131.547 76.3241 122.727C134.415 168.606 184.174 138.036 180.888 117.427C221.713 113.588 240.784 80.4586 223.796 43.582C206.809 6.75113 162.743 16.5758 149.32 28.3196Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.32 28.3196C149.32 28.3196 97.1998 -17.879 34.295 19.7745C-12.7332 47.9688 -6.20666 131.547 76.3241 122.727C134.415 168.606 184.174 138.036 180.888 117.427C221.713 113.588 240.784 80.4586 223.796 43.582C206.809 6.75113 162.743 16.5758 149.32 28.3196Z",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.32 28.3196C149.32 28.3196 97.1998 -17.879 34.295 19.7745C-12.7332 47.9688 -6.20666 131.547 76.3241 122.727C134.415 168.606 184.174 138.036 180.888 117.427C221.713 113.588 240.784 80.4586 223.796 43.582C206.809 6.75113 162.743 16.5758 149.32 28.3196Z",
    stroke: "#F4F6F8",
    strokeWidth: 10,
    mask: "url(#path-48-outside-3_58_978)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_58_978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 225,
    height: 142
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_47"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-4_58_978",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.32 28.3196C149.32 28.3196 97.1998 -17.879 34.295 19.7745C-12.7332 47.9688 -6.20666 131.547 76.3241 122.727C134.415 168.606 184.174 138.036 180.888 117.427C221.713 113.588 240.784 80.4586 223.796 43.582C206.809 6.75113 162.743 16.5758 149.32 28.3196Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.32 28.3196C149.32 28.3196 97.1998 -17.879 34.295 19.7745C-12.7332 47.9688 -6.20666 131.547 76.3241 122.727C134.415 168.606 184.174 138.036 180.888 117.427C221.713 113.588 240.784 80.4586 223.796 43.582C206.809 6.75113 162.743 16.5758 149.32 28.3196Z",
    fill: "#F4F6F8",
    stroke: "#CAD5DD",
    strokeWidth: 2,
    mask: "url(#path-49-inside-4_58_978)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_58_978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 49",
    x: -10,
    y: -4,
    width: 263,
    height: 159,
    fill: "url(#paint0_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BillsGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.2,
    d: "M132.085 6.4572L49.0537 40.1591L95.6482 154.954L178.68 121.252L132.085 6.4572Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M131.031 6.00004L48 39.7019L94.5945 154.497L177.626 120.795L131.031 6.00004Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.2,
    d: "M141.387 8.67223L54.9861 32.4454L87.8538 151.899L174.255 128.126L141.387 8.67223Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M140.375 8.10887L53.9744 31.8821L86.842 151.335L173.243 127.562L140.375 8.10887Z",
    fill: "#F1F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.2,
    d: "M149.87 12.1613L61.2025 25.1456L79.154 147.733L167.822 134.749L149.87 12.1613Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M148.933 11.4857L60.2653 24.47L78.2167 147.058L166.885 134.073L148.933 11.4857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M78.2494 47.6636L73.0424 48.4261L73.2657 49.9511L78.4727 49.1886L78.2494 47.6636Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M85.8658 46.9477L81.2543 47.623L81.4177 48.7387L86.0292 48.0634L85.8658 46.9477Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M91.4827 47.9919L81.515 49.4515L81.6784 50.5673L91.6461 49.1077L91.4827 47.9919Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M95.0594 47.4875L92.6419 47.8416L92.8053 48.9573L95.2228 48.6033L95.0594 47.4875Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M86.4323 50.7913L81.8204 51.4662L81.9837 52.582L86.5956 51.9071L86.4323 50.7913Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M89.4561 50.3464L87.0385 50.7004L87.2019 51.8162L89.6194 51.4622L89.4561 50.3464Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M92.569 49.8887L90.1517 50.2427L90.3151 51.3584L92.7324 51.0043L92.569 49.8887Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M95.6556 49.4526L93.2381 49.8064L93.4014 50.9222L95.8189 50.5684L95.6556 49.4526Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M98.7815 48.9947L96.364 49.3488L96.5273 50.4645L98.9449 50.1105L98.7815 48.9947Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M88.5284 52.5396L82.094 53.4812L82.2573 54.597L88.6916 53.6554L88.5284 52.5396Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M92.163 52.0019L89.7455 52.356L89.9089 53.4717L92.3264 53.1177L92.163 52.0019Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M92.6804 53.9882L82.3779 55.4958L82.5412 56.6116L92.8436 55.104L92.6804 53.9882Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M97.0788 53.3482L93.5083 53.8707L93.6716 54.9865L97.2421 54.464L97.0788 53.3482Z",
    fill: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M135.912 28.5111L133.494 28.8649L133.657 29.9807L136.075 29.6269L135.912 28.5111Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M139.032 28.06L136.615 28.4138L136.778 29.5296L139.195 29.1758L139.032 28.06Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M142.116 27.6112L139.698 27.965L139.862 29.0808L142.279 28.727L142.116 27.6112Z",
    fill: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M142.535 29.9256L133.869 31.1946L134.033 32.3104L142.699 31.0413L142.535 29.9256Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M130.601 40.4179L125.99 41.0928L126.153 42.2086L130.765 41.5337L130.601 40.4179Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M136.21 41.4595L126.243 42.9181L126.406 44.0339L136.374 42.5752L136.21 41.4595Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M139.773 40.9071L137.356 41.2611L137.519 42.3768L139.936 42.0228L139.773 40.9071Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M131.158 44.2402L126.547 44.9155L126.71 46.0312L131.321 45.3558L131.158 44.2402Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M134.176 43.8022L131.759 44.1562L131.922 45.2719L134.339 44.9179L134.176 43.8022Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M137.309 43.3533L134.891 43.7073L135.055 44.8231L137.472 44.469L137.309 43.3533Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M140.388 42.914L137.971 43.2678L138.134 44.3836L140.552 44.0298L140.388 42.914Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M143.503 42.4266L141.085 42.7804L141.249 43.8962L143.666 43.5424L143.503 42.4266Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M133.266 45.9933L126.831 46.9355L126.995 48.0513L133.429 47.1091L133.266 45.9933Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M136.891 45.4671L134.474 45.8209L134.637 46.9367L137.055 46.5829L136.891 45.4671Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M137.419 47.4385L127.117 48.9471L127.28 50.0629L137.583 48.5543L137.419 47.4385Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M141.805 46.7747L138.234 47.2972L138.398 48.413L141.968 47.8905L141.805 46.7747Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M122.867 41.124L117.66 41.8865L117.883 43.4114L123.09 42.6489L122.867 41.124Z",
    fill: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M140.585 104.905L132.142 106.14L132.289 107.145L140.732 105.909L140.585 104.905Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M141.063 107.85L136.042 108.585L136.189 109.589L141.21 108.854L141.063 107.85Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M129.778 109.366L126.951 109.78L127.136 111.045L129.963 110.631L129.778 109.366Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M130.228 112.45L127.401 112.864L127.587 114.129L130.413 113.715L130.228 112.45Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M141.512 110.915L136.267 111.683L136.414 112.687L141.659 111.919L141.512 110.915Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M141.736 113.958L124.257 116.517L124.404 117.521L141.883 114.962L141.736 113.958Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M74.7432 30.6805L68.4948 31.5948L68.7942 33.6405L75.0426 32.7261L74.7432 30.6805Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M75.3423 34.7632L69.0945 35.6782L69.2362 36.6451L75.4839 35.7301L75.3423 34.7632Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M72.6915 37.3949L69.4185 37.8739L69.56 38.8409L72.833 38.362L72.6915 37.3949Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M74.0062 39.2731L69.6918 39.9049L69.8334 40.8719L74.1478 40.2401L74.0062 39.2731Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M79.2673 38.521L74.9529 39.1523L75.0944 40.1194L79.4088 39.488L79.2673 38.521Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M84.565 37.7361L80.2506 38.3674L80.3921 39.3344L84.7065 38.7031L84.565 37.7361Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M93.5003 36.4499L85.5782 37.61L85.7198 38.577L93.6419 37.4169L93.5003 36.4499Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M76.8654 36.7931L73.5925 37.2721L73.734 38.2391L77.007 37.7602L76.8654 36.7931Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M81.4544 36.113L78.1814 36.5923L78.323 37.5593L81.596 37.08L81.4544 36.113Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M86.0396 35.4366L82.7666 35.9159L82.9082 36.8829L86.1812 36.4036L86.0396 35.4366Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M78.6398 34.2885L76.1478 34.6534L76.2894 35.6205L78.7814 35.2555L78.6398 34.2885Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M87.8353 28.7545L75.8964 30.5028L76.196 32.5484L88.1349 30.8001L87.8353 28.7545Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M97.0641 27.3793L89.4395 28.4958L89.7391 30.5415L97.3636 29.4249L97.0641 27.3793Z",
    fill: "#2C5A7A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M123.599 22.3647L124.163 26.1986L122.81 26.3866L122.246 22.5526L123.599 22.3647Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M127.17 21.8384L127.734 25.6724L126.569 25.8603L125.629 24.2065L125.892 25.9731L124.764 26.1234L124.201 22.2895L125.328 22.1391L126.343 23.7554L126.08 22.0264L127.17 21.8384Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M130.891 21.3123L130.778 25.259L128.749 25.5597L127.395 21.8385L128.824 21.613C129.162 22.6654 129.388 23.5299 129.576 24.2441C129.538 23.4923 129.5 22.8158 129.5 22.2519V21.5378L130.891 21.3123Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M134.537 23.0788C134.612 23.4547 134.612 23.7554 134.612 23.9058C134.612 24.0561 134.537 24.244 134.462 24.3944C134.349 24.5447 134.199 24.6575 133.973 24.7703C133.748 24.883 133.522 24.9582 133.222 24.9958C132.958 25.0334 132.695 25.0334 132.47 24.9958C132.244 24.9582 132.056 24.883 131.906 24.7703C131.756 24.6575 131.643 24.5072 131.605 24.3568C131.568 24.2065 131.493 23.9433 131.455 23.5299L131.342 22.8533C131.267 22.4774 131.267 22.1767 131.267 22.0264C131.267 21.876 131.342 21.6881 131.417 21.5377C131.53 21.3874 131.68 21.2746 131.906 21.1619C132.132 21.0491 132.357 20.9739 132.658 20.9363C132.921 20.8987 133.184 20.8987 133.41 20.9363C133.635 20.9739 133.823 21.0491 133.973 21.1619C134.124 21.2746 134.236 21.425 134.274 21.5753C134.312 21.7257 134.387 21.9888 134.424 22.4022L134.537 23.0788ZM132.996 21.9888C132.958 21.8008 132.958 21.6881 132.921 21.6505C132.883 21.6129 132.846 21.5753 132.733 21.6129C132.658 21.6129 132.62 21.6505 132.583 21.6881C132.545 21.7257 132.545 21.8384 132.583 22.064L132.846 23.8682C132.883 24.0937 132.921 24.244 132.958 24.2816C132.996 24.3192 133.034 24.3568 133.146 24.3192C133.222 24.3192 133.297 24.2816 133.297 24.2065C133.297 24.1313 133.297 23.9809 133.259 23.7554L132.996 21.9888Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M136.078 20.5228L136.642 24.3568L135.289 24.5447L134.725 20.7108L136.078 20.5228Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M139.987 21.6881L138.634 21.8761L138.521 21.1995C138.484 21.0116 138.446 20.8988 138.409 20.8236C138.371 20.786 138.296 20.7485 138.221 20.786C138.108 20.786 138.033 20.8236 138.033 20.8988C137.995 20.974 138.033 21.0867 138.033 21.2747L138.296 23.0789C138.334 23.2668 138.371 23.3796 138.409 23.4548C138.446 23.4924 138.521 23.5299 138.634 23.4924C138.747 23.4924 138.785 23.4548 138.822 23.3796C138.86 23.3044 138.822 23.1916 138.822 22.9661L138.747 22.4775L140.1 22.2895L140.138 22.4399C140.213 22.8534 140.213 23.1165 140.138 23.3044C140.1 23.4924 139.95 23.6427 139.687 23.8306C139.461 23.981 139.123 24.0938 138.747 24.1689C138.334 24.2441 138.033 24.2065 137.732 24.1689C137.469 24.0938 137.281 23.981 137.168 23.793C137.056 23.6051 136.98 23.342 136.905 22.9661L136.755 21.8385C136.717 21.5754 136.68 21.3499 136.717 21.1995C136.717 21.0492 136.792 20.8988 136.905 20.7485C137.018 20.5981 137.168 20.4853 137.394 20.3726C137.619 20.2598 137.845 20.1846 138.146 20.1471C138.559 20.0719 138.897 20.1095 139.16 20.1846C139.424 20.2598 139.612 20.3726 139.724 20.5229C139.837 20.6733 139.912 20.9364 139.95 21.3123L139.987 21.6881Z",
    fill: "#2C5A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M140.25 19.9215L142.506 19.5833L142.619 20.335L141.716 20.4854L141.829 21.1995L142.656 21.0868L142.769 21.8009L141.942 21.9137L142.055 22.7406L143.032 22.5903L143.145 23.342L140.814 23.6803L140.25 19.9215Z",
    fill: "#2C5A7A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M128.223 29.5816C128.335 29.544 128.448 29.5064 128.561 29.5064C128.786 29.4689 128.974 29.5064 129.087 29.5816C129.2 29.6568 129.313 29.8071 129.313 29.9951C129.35 30.183 129.313 30.371 129.2 30.5213C129.087 30.6717 128.899 30.7468 128.674 30.7844C128.561 30.7844 128.448 30.822 128.373 30.822L128.223 29.5816ZM128.561 30.6717C128.598 30.6717 128.674 30.6717 128.711 30.6717C129.05 30.6341 129.237 30.4085 129.162 30.0703C129.125 29.7696 128.937 29.6192 128.561 29.6568C128.486 29.6568 128.411 29.6944 128.373 29.6944L128.561 30.6717Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M129.764 30.2206L129.688 30.634L129.538 30.6716L129.764 29.3561L129.952 29.3185L130.553 30.5213L130.365 30.5589L130.177 30.183L129.764 30.2206ZM130.177 30.0326L129.989 29.6944C129.952 29.6192 129.914 29.544 129.876 29.4688C129.876 29.544 129.876 29.6192 129.839 29.6944L129.764 30.0702L130.177 30.0326Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M130.703 29.3184L130.328 29.356L130.29 29.2056L131.23 29.0553L131.267 29.2056L130.891 29.2808L131.042 30.4085L130.891 30.446L130.703 29.3184Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M132.132 29.6568L131.643 29.732L131.718 30.183L132.282 30.1079L132.32 30.2582L131.606 30.371L131.418 29.093L132.094 28.9802L132.132 29.1306L131.606 29.2057L131.681 29.6192L132.169 29.544L132.132 29.6568Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M132.32 29.4688C132.32 29.3937 132.357 29.3561 132.432 29.3185C132.508 29.3185 132.545 29.3561 132.545 29.4312C132.545 29.5064 132.508 29.544 132.432 29.5816C132.395 29.5816 132.357 29.544 132.32 29.4688ZM132.432 30.1454C132.432 30.0702 132.47 30.0326 132.545 29.9951C132.62 29.9951 132.658 30.0326 132.658 30.1078C132.658 30.183 132.62 30.2206 132.545 30.2582C132.508 30.2582 132.432 30.2206 132.432 30.1454Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M124.99 32.4382L125.178 33.7162L125.028 33.7538L124.84 32.4758L124.99 32.4382Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M125.479 33.641L125.291 32.363L125.479 32.3254L125.967 32.8892C126.08 33.0396 126.193 33.1523 126.268 33.2651C126.23 33.1147 126.193 32.9268 126.155 32.7389L126.08 32.2126L126.23 32.175L126.418 33.453L126.268 33.4906L125.779 32.8892C125.667 32.7765 125.554 32.6261 125.479 32.5133C125.516 32.6637 125.554 32.814 125.554 33.0396L125.629 33.5658L125.479 33.641Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M126.982 33.4155L126.381 32.2127L126.569 32.1751L126.869 32.7765C126.945 32.9269 127.02 33.0772 127.057 33.2276C127.057 33.0772 127.095 32.9269 127.133 32.739L127.245 32.1L127.433 32.0624L127.17 33.3779L126.982 33.4155Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M128.749 32.5134C128.824 32.9645 128.598 33.2276 128.26 33.2652C127.922 33.3028 127.659 33.0773 127.584 32.7014C127.508 32.2879 127.734 31.9872 128.072 31.9496C128.411 31.912 128.674 32.1376 128.749 32.5134ZM127.772 32.6638C127.809 32.9269 127.997 33.1524 128.26 33.1148C128.523 33.0773 128.636 32.8141 128.598 32.5134C128.561 32.2503 128.411 32.0248 128.11 32.0624C127.809 32.1376 127.696 32.4007 127.772 32.6638Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M129.012 31.8368L129.2 33.1148L129.049 33.1524L128.862 31.8744L129.012 31.8368Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M130.365 32.8892C130.327 32.9268 130.177 32.9644 130.027 33.0019C129.688 33.0395 129.388 32.8516 129.313 32.4381C129.237 32.0247 129.501 31.724 129.876 31.6864C130.027 31.6488 130.14 31.6864 130.177 31.6864L130.14 31.8367C130.064 31.7991 129.989 31.7991 129.876 31.8367C129.576 31.8743 129.425 32.0998 129.463 32.4381C129.501 32.7388 129.726 32.9268 130.027 32.8892C130.14 32.8892 130.215 32.8516 130.29 32.814L130.365 32.8892Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M131.154 32.2127L130.666 32.2879L130.741 32.7389L131.305 32.6638L131.342 32.8141L130.628 32.9269L130.44 31.6489L131.117 31.5361L131.154 31.6865L130.628 31.7617L130.703 32.1751L131.192 32.0999L131.154 32.2127Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M131.944 32.7013V32.3254L131.756 32.363V32.2503L131.944 32.2127V31.9496L131.793 31.9872V31.8744L131.981 31.8368V31.4609H132.094V31.8368L132.282 31.7992V31.4233H132.395V31.7992L132.545 31.7616V31.8744L132.357 31.912V32.1751L132.508 32.1375V32.2503L132.32 32.2879V32.6637H132.207V32.2879L132.019 32.3254V32.7013H131.944ZM132.244 32.1751V31.912L132.056 31.9496V32.2127L132.244 32.1751Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M132.658 31.8369C132.658 31.7617 132.696 31.7241 132.771 31.6865C132.846 31.6865 132.883 31.7241 132.883 31.7993C132.883 31.8745 132.846 31.9121 132.771 31.9496C132.733 31.9121 132.696 31.8745 132.658 31.8369ZM132.771 32.4759C132.771 32.4007 132.808 32.3631 132.883 32.3255C132.959 32.3255 132.996 32.3631 132.996 32.4383C132.996 32.5135 132.959 32.551 132.883 32.5886C132.846 32.5886 132.771 32.551 132.771 32.4759Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M145.602 33.3182L69.7289 44.429L70.0394 46.5489L145.913 35.4382L145.602 33.3182Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M83.1085 62.2418L72.5457 63.7886L72.9923 66.8384L83.5551 65.2916L83.1085 62.2418Z",
    fill: "#E7EFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M83.6439 65.365L72.9314 66.9437L72.4803 63.7487L83.1928 62.17L83.6439 65.365ZM73.0442 66.7181L83.4559 65.177L83.0425 62.2828L72.6307 63.8239L73.0442 66.7181Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M101.86 59.4969L83.1145 62.2419L83.5611 65.2918L102.306 62.5468L101.86 59.4969Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M102.362 62.621L83.4934 65.4024L83.0424 62.2075L101.911 59.426L102.362 62.621ZM83.6062 65.1769L102.174 62.4706L101.761 59.5764L83.1927 62.2827L83.6062 65.1769Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M111.079 58.1257L101.855 59.4764L102.302 62.5263L111.526 61.1755L111.079 58.1257Z",
    fill: "#E7EFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M111.609 61.2678L102.212 62.6586L101.761 59.4636L111.158 58.0729L111.609 61.2678ZM102.362 62.433L111.421 61.1175L111.007 58.2232L101.949 59.5388L102.362 62.433Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M122.383 56.4752L111.113 58.1255L111.56 61.1753L122.829 59.525L122.383 56.4752Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M122.923 59.614L111.496 61.2679L111.045 58.0729L122.472 56.4191L122.923 59.614ZM111.609 61.0799L122.697 59.4637L122.284 56.5694L111.195 58.1857L111.609 61.0799Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M134.326 54.7338L122.276 56.4972L122.722 59.547L134.772 57.7836L134.326 54.7338Z",
    fill: "#E7EFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M134.838 57.8474L122.622 59.6516L122.171 56.4567L134.387 54.6525L134.838 57.8474ZM122.772 59.4637L134.65 57.7346L134.237 54.8404L122.359 56.5694L122.772 59.4637Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M148.417 52.6578L134.321 54.722L134.767 57.7719L148.864 55.7077L148.417 52.6578Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M148.933 55.7801L134.688 57.885L134.237 54.6901L148.482 52.5852L148.933 55.7801ZM134.838 57.6971L148.783 55.6674L148.37 52.7731L134.425 54.8029L134.838 57.6971Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M83.5588 65.2861L72.996 66.8329L73.4426 69.8827L84.0054 68.3359L83.5588 65.2861Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M84.0948 68.4095L73.3824 69.9882L72.9313 66.7933L83.6438 65.2146L84.0948 68.4095ZM73.4951 69.8003L83.9069 68.2592L83.4934 65.365L73.0817 66.906L73.4951 69.8003Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M102.31 62.5411L83.5651 65.2861L84.0117 68.336L102.757 65.591L102.31 62.5411Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M102.814 65.6656L83.9446 68.4471L83.4935 65.2522L102.362 62.4707L102.814 65.6656ZM84.0573 68.2592L102.626 65.5529L102.212 62.6586L83.6439 65.3649L84.0573 68.2592Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M111.493 61.175L102.269 62.5258L102.715 65.5756L111.939 64.2249L111.493 61.175Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M112.06 64.3125L102.663 65.7032L102.212 62.5083L111.609 61.1176L112.06 64.3125ZM102.776 65.5153L111.835 64.1997L111.421 61.3055L102.362 62.6211L102.776 65.5153Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M122.833 59.5189L111.564 61.1692L112.01 64.219L123.28 62.5687L122.833 59.5189Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M123.374 62.6586L111.947 64.3124L111.496 61.1175L122.923 59.4636L123.374 62.6586ZM112.06 64.1245L123.148 62.5082L122.735 59.614L111.647 61.2302L112.06 64.1245Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M134.783 57.7672L122.732 59.5319L123.179 62.5817L135.229 60.817L134.783 57.7672Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M135.289 60.892L123.073 62.6962L122.622 59.5012L134.838 57.697L135.289 60.892ZM123.223 62.5082L135.101 60.7792L134.688 57.885L122.81 59.614L123.223 62.5082Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M148.868 55.7015L134.771 57.7657L135.218 60.8156L149.314 58.7514L148.868 55.7015Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M149.385 58.8247L135.139 60.9296L134.688 57.7347L148.934 55.6298L149.385 58.8247ZM135.289 60.7417L149.234 58.7119L148.821 55.8177L134.876 57.8474L135.289 60.7417Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M112.463 67.4437L73.9312 73.0862L74.3833 76.1732L112.915 70.5307L112.463 67.4437Z",
    fill: "#E7EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M112.962 70.5896L74.2845 76.2653L73.7959 73.0328L112.474 67.3571L112.962 70.5896ZM74.4349 76.0774L112.774 70.4768L112.361 67.545L74.0214 73.1455L74.4349 76.0774Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M123.736 65.7974L112.467 67.4476L112.919 70.5346L124.188 68.8844L123.736 65.7974Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M124.276 68.9358L112.849 70.5896L112.361 67.3571L123.787 65.7032L124.276 68.9358ZM113 70.4393L124.088 68.823L123.675 65.8912L112.586 67.5075L113 70.4393Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M135.685 64.0537L123.709 65.8075L124.161 68.8945L136.138 67.1407L135.685 64.0537Z",
    fill: "#E7EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M136.229 67.2068L124.126 68.9734L123.637 65.7409L135.74 63.9742L136.229 67.2068ZM124.238 68.7854L136.041 67.0564L135.627 64.1246L123.825 65.8536L124.238 68.7854Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M149.767 61.9769L135.597 64.052L136.049 67.139L150.22 65.0639L149.767 61.9769Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M150.324 65.1394L136.003 67.2443L135.515 64.0118L149.836 61.9069L150.324 65.1394ZM136.116 67.0564L150.136 64.989L149.723 62.0572L135.703 64.1245L136.116 67.0564Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M155.558 101.52L141.388 103.596L141.84 106.683L156.01 104.607L155.558 101.52Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M156.113 104.682L141.792 106.786L141.303 103.554L155.624 101.449L156.113 104.682ZM141.905 106.598L155.925 104.531L155.511 101.599L141.491 103.667L141.905 106.598Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M156.001 104.613L141.83 106.686L142.282 109.773L156.452 107.7L156.001 104.613Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M156.564 107.764L142.243 109.869L141.754 106.636L156.075 104.531L156.564 107.764ZM142.356 109.681L156.376 107.613L155.962 104.681L141.942 106.749L142.356 109.681Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M156.462 107.685L142.292 109.76L142.744 112.847L156.914 110.772L156.462 107.685Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M157.015 110.808L142.694 112.913L142.205 109.681L156.526 107.576L157.015 110.808ZM142.807 112.763L156.827 110.696L156.413 107.764L142.393 109.831L142.807 112.763Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M156.914 110.767L142.744 112.842L143.196 115.929L157.366 113.854L156.914 110.767Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M157.466 113.891L143.145 115.996L142.656 112.763L156.977 110.658L157.466 113.891ZM143.258 115.808L157.278 113.74L156.864 110.808L142.844 112.876L143.258 115.808Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M157.356 113.859L143.186 115.933L143.638 119.02L157.808 116.946L157.356 113.859Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M157.917 116.973L143.596 119.078L143.107 115.845L157.428 113.74L157.917 116.973ZM143.709 118.89L157.729 116.822L157.315 113.928L143.295 115.995L143.709 118.89Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M157.818 116.931L143.648 119.006L144.1 122.093L158.27 120.018L157.818 116.931Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M158.368 120.055L144.047 122.16L143.558 118.927L157.879 116.822L158.368 120.055ZM144.16 121.972L158.18 119.904L157.766 116.973L143.746 119.04L144.16 121.972Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M158.265 119.976L144.095 122.051L144.547 125.138L158.717 123.063L158.265 119.976Z",
    fill: "#D9E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M158.819 123.137L144.498 125.242L144.01 122.009L158.33 119.904L158.819 123.137ZM144.611 125.054L158.631 122.987L158.218 120.055L144.197 122.122L144.611 125.054Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M112.913 70.5162L74.3809 76.1587L79.7239 112.645L118.256 107.002L112.913 70.5162Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M118.3 107.05L79.622 112.725L74.2469 76.1151L112.925 70.4393L118.3 107.05ZM79.7723 112.537L118.112 106.937L112.812 70.6273L74.4725 76.2278L79.7723 112.537Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M124.185 68.8701L112.916 70.5204L118.259 107.007L129.528 105.356L124.185 68.8701Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M129.613 105.396L118.187 107.05L112.812 70.4394L124.238 68.7855L129.613 105.396ZM118.337 106.899L129.425 105.283L124.126 68.9735L113.037 70.5897L118.337 106.899Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M136.136 67.1253L124.16 68.879L129.503 105.365L141.479 103.612L136.136 67.1253Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M141.566 103.667L129.463 105.433L124.088 68.8231L136.191 67.0565L141.566 103.667ZM129.576 105.245L141.378 103.516L136.079 67.2069L124.276 68.9359L129.576 105.245Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M150.217 65.0494L136.047 67.1245L141.39 103.611L155.56 101.536L150.217 65.0494Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M155.662 101.599L141.341 103.704L135.966 67.0939L150.286 64.989L155.662 101.599ZM141.453 103.516L155.474 101.449L150.174 65.1394L136.154 67.2067L141.453 103.516Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M137.808 117.762L137.432 117.8L137.394 117.649L138.334 117.499L138.371 117.649L137.996 117.725L138.146 118.852L137.996 118.89L137.808 117.762Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M139.612 117.988C139.687 118.439 139.461 118.702 139.123 118.739C138.785 118.777 138.522 118.551 138.447 118.176C138.371 117.762 138.597 117.461 138.935 117.424C139.311 117.386 139.574 117.612 139.612 117.988ZM138.635 118.138C138.672 118.401 138.86 118.627 139.123 118.589C139.386 118.551 139.499 118.288 139.461 117.988C139.424 117.725 139.274 117.499 138.973 117.537C138.71 117.612 138.597 117.875 138.635 118.138Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M139.95 117.461L139.574 117.499L139.537 117.349L140.476 117.198L140.514 117.349L140.138 117.424L140.288 118.552L140.138 118.589L139.95 117.461Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M140.815 118.063L140.739 118.476L140.589 118.514L140.852 117.198L141.04 117.161L141.641 118.364L141.453 118.401L141.266 118.025L140.815 118.063ZM141.19 117.875L141.002 117.537C140.965 117.461 140.927 117.386 140.89 117.311C140.89 117.386 140.89 117.461 140.852 117.537L140.777 117.913L141.19 117.875Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M141.642 117.048L141.792 117.01L141.942 118.138L142.468 118.063L142.506 118.213L141.792 118.326L141.642 117.048Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M139.311 120.544C139.386 120.506 139.499 120.506 139.612 120.468C139.762 120.431 139.913 120.468 139.988 120.506C140.063 120.544 140.138 120.656 140.138 120.769C140.138 120.882 140.138 120.995 140.063 121.07C139.988 121.182 139.875 121.258 139.687 121.258C139.649 121.258 139.612 121.258 139.537 121.258L139.612 121.746L139.462 121.784L139.311 120.544ZM139.574 121.145C139.612 121.145 139.649 121.145 139.725 121.145C139.913 121.107 140.025 120.995 139.988 120.844C139.95 120.694 139.837 120.619 139.649 120.656C139.574 120.656 139.537 120.694 139.499 120.694L139.574 121.145Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M140.476 121.258L140.401 121.671L140.213 121.709L140.476 120.393L140.664 120.356L141.266 121.558L141.078 121.596L140.89 121.22L140.476 121.258ZM140.89 121.07L140.702 120.731C140.664 120.656 140.627 120.581 140.589 120.506C140.589 120.581 140.589 120.656 140.551 120.731L140.476 121.107L140.89 121.07Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M141.454 120.243L141.642 121.521L141.491 121.558L141.303 120.28L141.454 120.243Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M141.754 120.205C141.867 120.168 141.98 120.13 142.093 120.13C142.318 120.093 142.506 120.13 142.619 120.205C142.732 120.28 142.844 120.431 142.882 120.619C142.919 120.844 142.882 120.995 142.769 121.145C142.656 121.295 142.468 121.37 142.243 121.408C142.13 121.408 142.017 121.446 141.942 121.446L141.754 120.205ZM142.093 121.295C142.13 121.295 142.205 121.295 142.243 121.295C142.581 121.258 142.769 121.032 142.694 120.694C142.656 120.393 142.468 120.243 142.093 120.28C142.017 120.28 141.942 120.318 141.905 120.318L142.093 121.295Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M134.951 124.453L134.575 124.49L134.537 124.34L135.477 124.189L135.515 124.34L135.139 124.415L135.289 125.543L135.139 125.58L134.951 124.453Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M136.755 124.678C136.83 125.129 136.605 125.392 136.266 125.43C135.928 125.467 135.665 125.242 135.59 124.866C135.515 124.453 135.74 124.152 136.078 124.114C136.454 124.077 136.717 124.302 136.755 124.678ZM135.778 124.866C135.815 125.129 136.003 125.355 136.266 125.317C136.529 125.28 136.642 125.016 136.605 124.716C136.567 124.453 136.379 124.227 136.116 124.265C135.853 124.302 135.74 124.565 135.778 124.866Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M137.093 124.152L136.717 124.189L136.68 124.039L137.619 123.889L137.657 124.039L137.281 124.114L137.432 125.242L137.281 125.28L137.093 124.152Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M137.958 124.753L137.883 125.167L137.732 125.204L137.958 123.889L138.146 123.851L138.747 125.054L138.559 125.092L138.371 124.716L137.958 124.753ZM138.371 124.565L138.183 124.227C138.146 124.152 138.108 124.077 138.07 124.002C138.07 124.077 138.07 124.152 138.033 124.227L137.958 124.603L138.371 124.565Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M138.785 123.776L138.935 123.738L139.085 124.866L139.612 124.791L139.649 124.941L138.935 125.054L138.785 123.776Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M140.063 123.588C140.175 123.551 140.288 123.513 140.401 123.513C140.626 123.475 140.814 123.513 140.927 123.588C141.04 123.663 141.153 123.814 141.19 124.002C141.228 124.189 141.19 124.377 141.077 124.528C140.965 124.678 140.777 124.753 140.551 124.791C140.438 124.791 140.326 124.828 140.251 124.828L140.063 123.588ZM140.401 124.678C140.438 124.678 140.514 124.678 140.551 124.678C140.89 124.641 141.077 124.415 141.002 124.077C140.965 123.776 140.777 123.626 140.401 123.663C140.326 123.663 140.251 123.701 140.213 123.701L140.401 124.678Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M141.453 123.363L141.566 124.114C141.604 124.415 141.754 124.49 141.904 124.49C142.092 124.453 142.205 124.302 142.168 124.039L142.055 123.287L142.205 123.25L142.318 124.002C142.393 124.378 142.205 124.565 141.904 124.603C141.641 124.641 141.416 124.528 141.378 124.114L141.265 123.363H141.453Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M143.258 123.776L142.769 123.851L142.844 124.302L143.408 124.227L143.446 124.377L142.731 124.49L142.543 123.212L143.22 123.099L143.258 123.25L142.731 123.325L142.807 123.738L143.295 123.663L143.258 123.776Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M158.986 124.174L82.9633 135.306L83.6495 139.993L159.672 128.86L158.986 124.174Z",
    fill: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M112.135 132.346L111.308 132.459L111.271 132.158L113.263 131.857L113.3 132.158L112.473 132.271L112.812 134.676L112.473 134.714L112.135 132.346Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M113.939 131.782L114.09 132.91L115.405 132.722L115.255 131.594L115.593 131.557L116.007 134.263L115.668 134.301L115.48 133.023L114.165 133.21L114.353 134.488L114.014 134.526L113.601 131.82L113.939 131.782Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M116.909 133.248L116.758 134.15L116.383 134.188L116.909 131.369L117.322 131.294L118.638 133.85L118.262 133.887L117.848 133.098L116.909 133.248ZM117.773 132.835L117.397 132.083C117.322 131.933 117.247 131.745 117.172 131.594C117.172 131.745 117.134 131.933 117.097 132.12L116.946 132.947L117.773 132.835Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M119.051 133.774L118.638 131.068L119.014 131.03L120.066 132.271C120.329 132.572 120.517 132.835 120.668 133.06C120.592 132.722 120.517 132.384 120.48 131.97L120.329 130.843L120.668 130.805L121.081 133.511L120.743 133.549L119.69 132.308C119.465 132.045 119.239 131.745 119.051 131.482C119.127 131.82 119.164 132.158 119.239 132.609L119.39 133.774H119.051Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M121.306 130.692L121.645 130.654L121.833 131.97C121.908 131.857 121.945 131.745 122.021 131.669L122.697 130.542L123.111 130.467L122.284 131.745L123.562 133.135L123.148 133.21L122.058 132.008L121.833 132.346L121.983 133.361L121.645 133.398L121.306 130.692Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M125.14 132.91L124.99 131.782L123.9 130.354L124.313 130.279L124.802 130.955C124.952 131.143 125.028 131.294 125.14 131.482C125.178 131.294 125.253 131.106 125.328 130.88L125.591 130.091L126.005 130.016L125.328 131.707L125.479 132.872L125.14 132.91Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M128.636 130.993C128.786 131.932 128.298 132.496 127.584 132.609C126.869 132.722 126.306 132.233 126.155 131.406C126.043 130.542 126.494 129.903 127.208 129.79C127.997 129.677 128.523 130.166 128.636 130.993ZM126.569 131.331C126.644 131.895 127.057 132.384 127.584 132.308C128.147 132.233 128.373 131.669 128.298 131.068C128.223 130.542 127.847 130.016 127.283 130.091C126.682 130.166 126.494 130.73 126.569 131.331Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M129.275 129.527L129.501 131.143C129.576 131.745 129.914 131.97 130.252 131.895C130.666 131.82 130.854 131.519 130.779 130.955L130.553 129.339L130.891 129.302L131.117 130.88C131.23 131.707 130.854 132.121 130.252 132.196C129.689 132.271 129.237 132.008 129.125 131.181L128.899 129.602L129.275 129.527Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M74.3599 65.7408L74.1719 64.4628L74.3599 64.4253L74.8485 64.9891C74.9613 65.1394 75.074 65.2522 75.1492 65.3649C75.1116 65.2146 75.074 65.0267 75.0365 64.8387L74.9613 64.3125L75.1116 64.2749L75.2996 65.5529L75.1492 65.5905L74.6606 64.9891C74.5478 64.8763 74.435 64.726 74.3599 64.6132C74.3975 64.7635 74.435 64.9139 74.435 65.1394L74.5102 65.6656L74.3599 65.7408Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M76.3143 65.2145C76.3143 65.3273 76.3519 65.4025 76.3519 65.4777L76.2015 65.5153L76.1639 65.3649C76.1263 65.4401 76.0512 65.5528 75.9008 65.5904C75.7505 65.628 75.5625 65.5528 75.5249 65.2521L75.4498 64.7259L75.6001 64.6883L75.6753 65.177C75.7129 65.3649 75.7881 65.4401 75.9384 65.4401C76.0512 65.4401 76.1263 65.3273 76.1263 65.2521C76.1263 65.2146 76.1263 65.177 76.1263 65.177L76.0512 64.6132L76.2015 64.5756L76.3143 65.2145Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M76.5399 64.726C76.5399 64.6508 76.5023 64.538 76.5023 64.5004L76.6527 64.4628L76.6903 64.6132C76.7278 64.538 76.803 64.4253 76.9534 64.3877C77.0661 64.3877 77.1789 64.4253 77.2541 64.538C77.2917 64.5004 77.2917 64.4253 77.3292 64.3877C77.3668 64.3501 77.442 64.3125 77.5172 64.3125C77.6299 64.3125 77.8179 64.3501 77.8555 64.6508L77.9306 65.177L77.7803 65.2146L77.7051 64.6884C77.6675 64.5004 77.5924 64.4253 77.4796 64.4253C77.4044 64.4253 77.3292 64.538 77.2917 64.6132C77.2917 64.6508 77.2917 64.6508 77.2917 64.6884L77.3668 65.2522L77.2165 65.2898L77.1413 64.7635C77.1037 64.6132 77.0285 64.538 76.9158 64.538C76.803 64.538 76.7654 64.6508 76.7278 64.726C76.7278 64.7636 76.7278 64.7636 76.7278 64.8011L76.803 65.365L76.6527 65.4025L76.5399 64.726Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M78.1937 65.177C78.1937 65.1018 78.1937 65.0267 78.1561 64.9515L78.0058 63.8614L78.1561 63.8239L78.2313 64.3877C78.2689 64.2749 78.3817 64.1997 78.532 64.1621C78.7575 64.1246 78.9455 64.2749 78.9831 64.5756C79.0207 64.9139 78.8327 65.1018 78.6448 65.1394C78.532 65.177 78.4193 65.1394 78.3065 65.0267V65.177H78.1937ZM78.3065 64.8011C78.3065 64.8387 78.3065 64.8387 78.3065 64.8763C78.3441 64.9891 78.4568 65.0642 78.5696 65.0267C78.7575 64.9891 78.8327 64.8387 78.7951 64.6508C78.7576 64.4628 78.6448 64.3125 78.4944 64.3501C78.3817 64.3501 78.3065 64.4628 78.2689 64.5756C78.2689 64.6132 78.2689 64.6132 78.2689 64.6508L78.3065 64.8011Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M79.2837 64.5757C79.3213 64.8012 79.4717 64.8764 79.6596 64.8388C79.7724 64.8388 79.8476 64.8012 79.9227 64.7636L79.9603 64.8764C79.9227 64.9139 79.81 64.9515 79.6596 64.9891C79.3965 65.0267 79.171 64.8764 79.1334 64.6132C79.0958 64.3501 79.2086 64.087 79.4717 64.0494C79.7724 64.0118 79.8851 64.2374 79.9227 64.4253C79.9227 64.4629 79.9227 64.5005 79.9227 64.5005L79.2837 64.5757ZM79.7348 64.3877C79.7348 64.275 79.6596 64.1246 79.4717 64.1622C79.3213 64.1998 79.2462 64.3501 79.2462 64.4629L79.7348 64.3877Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M80.1106 64.2749C80.1106 64.1622 80.0731 64.087 80.0731 63.9742L80.2234 63.9366L80.261 64.1246C80.2986 64.0118 80.3738 63.899 80.4865 63.899H80.5241L80.5617 64.0494C80.5617 64.0494 80.5241 64.0494 80.4865 64.0494C80.3738 64.0494 80.2986 64.1622 80.2986 64.3125C80.2986 64.3501 80.2986 64.3501 80.2986 64.3877L80.3738 64.8763L80.2234 64.9139L80.1106 64.2749Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M81.2383 64.7259V64.35L81.088 64.3876V64.2748L81.2759 64.2372V63.9741L81.1255 64.0117V63.8989L81.3135 63.8613V63.4855H81.4262V63.8613L81.6142 63.8238V63.4479H81.7269V63.8238L81.8773 63.7862V63.8989L81.6894 63.9365V64.1996L81.8397 64.162V64.2748L81.6518 64.3124V64.6883H81.539V64.3124L81.3511 64.35V64.7259H81.2383ZM81.539 64.1996V63.9365L81.3511 63.9741V64.2372L81.539 64.1996Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M86.4631 63.5983C86.5383 63.6359 86.6511 63.6734 86.7638 63.6359C86.9142 63.5983 87.027 63.5231 86.9894 63.3727C86.9894 63.26 86.8766 63.1848 86.7263 63.1472C86.5007 63.1096 86.3504 63.0345 86.3504 62.8465C86.3128 62.6586 86.4631 62.4706 86.7263 62.433C86.839 62.3955 86.9518 62.4331 87.027 62.4706L86.9894 62.621C86.9518 62.621 86.839 62.5834 86.7263 62.5834C86.5383 62.621 86.5007 62.7337 86.5007 62.8089C86.5007 62.9217 86.6135 62.9593 86.8014 63.0345C87.027 63.072 87.1397 63.1848 87.1773 63.3727C87.2149 63.5607 87.1021 63.7486 86.8014 63.7862C86.6887 63.7862 86.5383 63.7862 86.4631 63.7486V63.5983Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M87.929 63.5607L87.8914 63.448C87.8538 63.5232 87.7786 63.5983 87.6283 63.6359C87.4403 63.6735 87.3276 63.5607 87.3276 63.4104C87.29 63.1849 87.4779 63.0345 87.8162 62.9969V62.9593C87.8162 62.8842 87.7786 62.7338 87.5907 62.7714C87.5155 62.7714 87.4403 62.809 87.3651 62.8842L87.3276 62.7714C87.4027 62.6962 87.5155 62.6586 87.6283 62.6586C87.8914 62.6211 88.0041 62.809 88.0417 62.9969L88.0793 63.3352C88.0793 63.4104 88.1169 63.4856 88.1169 63.5607H87.929ZM87.8538 63.1097C87.6658 63.1473 87.4779 63.1849 87.5155 63.3728C87.5155 63.4856 87.6283 63.5232 87.7034 63.5232C87.8162 63.5232 87.8914 63.4104 87.8914 63.3352V63.2976L87.8538 63.1097Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M88.1545 62.1699L88.3049 62.1323L88.4928 63.4479L88.3425 63.4855L88.1545 62.1699Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M88.831 62.9969C88.8686 63.2224 89.019 63.2976 89.2069 63.26C89.3197 63.26 89.3949 63.2224 89.47 63.1849L89.5076 63.2976C89.47 63.3352 89.3573 63.3728 89.2069 63.4104C88.9438 63.448 88.7183 63.2976 88.6807 63.0345C88.6431 62.7714 88.7559 62.5083 89.019 62.4707C89.3197 62.4331 89.4324 62.6586 89.47 62.8466C89.47 62.8842 89.47 62.9217 89.47 62.9217L88.831 62.9969ZM89.2821 62.809C89.2821 62.6962 89.2069 62.5459 89.019 62.5835C88.8686 62.621 88.7935 62.7714 88.7935 62.8842L89.2821 62.809Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M89.6957 63.1472C89.7333 63.1848 89.846 63.1848 89.9212 63.1848C90.0339 63.1848 90.0715 63.1097 90.0715 63.0345C90.0715 62.9593 89.9964 62.9217 89.8836 62.8841C89.6957 62.8465 89.6205 62.7714 89.6205 62.6586C89.5829 62.5083 89.6957 62.3579 89.8836 62.3579C89.9588 62.3579 90.0715 62.3579 90.1091 62.3955L90.0715 62.5083C90.034 62.5083 89.9588 62.4707 89.8836 62.4707C89.7708 62.4707 89.7332 62.5458 89.7332 62.621C89.7332 62.6962 89.8084 62.7338 89.9212 62.7338C90.0715 62.7714 90.1843 62.8465 90.1843 62.9593C90.2219 63.1097 90.1091 63.26 89.8836 63.2976C89.7708 63.2976 89.6957 63.2976 89.6205 63.26L89.6957 63.1472Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M90.6729 61.9069C90.748 61.8693 90.8608 61.8693 90.9736 61.8317C91.1615 61.7941 91.2743 61.8317 91.3494 61.8693C91.4246 61.9069 91.4622 61.9821 91.4998 62.0948C91.5374 62.2452 91.4246 62.3955 91.3118 62.4707C91.4246 62.5083 91.4998 62.5835 91.5374 62.6962C91.6125 62.8842 91.6501 62.997 91.6877 63.0345L91.5374 63.0721C91.4998 63.0345 91.4622 62.9218 91.4246 62.7714C91.3494 62.5835 91.2743 62.5459 91.1239 62.5459L90.9736 62.5835L91.0487 63.1473L90.8984 63.1849L90.6729 61.9069ZM90.936 62.4331L91.0863 62.3955C91.2743 62.358 91.3494 62.2452 91.3494 62.0948C91.3118 61.9445 91.1991 61.8693 91.0111 61.9069C90.936 61.9069 90.8608 61.9445 90.8608 61.9445L90.936 62.4331Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M91.9133 62.5459C91.9509 62.7714 92.1013 62.8466 92.2892 62.809C92.402 62.809 92.4771 62.7714 92.5523 62.7338L92.5899 62.8466C92.5523 62.8842 92.4395 62.9217 92.2892 62.9593C92.0261 62.9969 91.8006 62.8466 91.763 62.5835C91.7254 62.3203 91.8381 62.0572 92.1013 62.0196C92.402 61.9821 92.5147 62.2076 92.5523 62.3955C92.5523 62.4331 92.5523 62.4707 92.5523 62.4707L91.9133 62.5459ZM92.3644 62.3579C92.3644 62.2452 92.2892 62.0948 92.1013 62.1324C91.9509 62.17 91.8757 62.3203 91.8757 62.4331L92.3644 62.3579Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M92.7403 62.2452C92.7403 62.1324 92.7027 62.0197 92.7027 61.9445L92.853 61.9069L92.8906 62.0573C92.9282 61.9445 93.041 61.8693 93.1913 61.8317C93.4169 61.7941 93.6048 61.9445 93.6424 62.2452C93.68 62.5835 93.5296 62.7714 93.3041 62.809C93.1913 62.809 93.0786 62.7714 93.0034 62.6962L93.0786 63.1849L92.9282 63.2225L92.7403 62.2452ZM92.9282 62.4707C92.9282 62.5083 92.9282 62.5083 92.9282 62.5459C92.9658 62.6587 93.0786 62.7338 93.1913 62.6962C93.3793 62.6587 93.4544 62.5083 93.4169 62.3204C93.3793 62.1324 93.2665 61.9821 93.1162 62.0197C93.0034 62.0197 92.9282 62.1324 92.8906 62.2452C92.8906 62.2828 92.8906 62.2828 92.8906 62.3204L92.9282 62.4707Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M93.7927 62.6211C93.7927 62.5459 93.8303 62.5083 93.9054 62.4707C93.9806 62.4707 94.0182 62.5083 94.0182 62.5835C94.0182 62.6586 93.9806 62.6962 93.9054 62.7338C93.8678 62.7338 93.7927 62.6962 93.7927 62.6211Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M94.6572 62.5835L94.4692 61.3055L94.6572 61.2679L95.1458 61.8317C95.2586 61.9821 95.3713 62.0948 95.4465 62.2076C95.4089 62.0572 95.3713 61.9069 95.3338 61.6814L95.2586 61.1551L95.4089 61.1176L95.5969 62.3955L95.4465 62.4331L94.9579 61.8693C94.8451 61.7565 94.7324 61.6062 94.6572 61.4934C94.6948 61.6438 94.7324 61.7941 94.7324 62.0197L94.8075 62.5459L94.6572 62.5835Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M96.3861 62.3203L96.3485 62.2075C96.3109 62.2827 96.2358 62.3579 96.0854 62.3954C95.8975 62.433 95.7847 62.3203 95.7847 62.1699C95.7471 61.9444 95.9351 61.794 96.2734 61.7565V61.7189C96.2734 61.6437 96.2358 61.4933 96.0478 61.5309C95.9726 61.5309 95.8599 61.5685 95.8223 61.6437L95.7847 61.5309C95.8599 61.4558 95.9727 61.4182 96.0854 61.4182C96.3485 61.3806 96.4613 61.5685 96.4989 61.7565L96.5365 62.0947C96.5365 62.1699 96.574 62.2451 96.574 62.3203H96.3861ZM96.2734 61.8692C96.0854 61.9068 95.8975 61.9444 95.9351 62.1323C95.9351 62.2451 96.0478 62.2827 96.123 62.2827C96.2358 62.2827 96.3109 62.1699 96.3109 62.0947V62.0572L96.2734 61.8692Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M96.6869 61.6062C96.6869 61.531 96.6493 61.4183 96.6493 61.3431L96.7996 61.3055L96.8372 61.4558C96.8748 61.3431 96.95 61.2679 97.1003 61.2303C97.2131 61.2303 97.3259 61.2679 97.401 61.3807C97.4386 61.3431 97.4386 61.2679 97.4762 61.2303C97.5138 61.1927 97.589 61.1552 97.6642 61.1552C97.7769 61.1552 97.9649 61.1927 98.0024 61.4934L98.0776 62.0197L97.9273 62.0573L97.8521 61.531C97.8145 61.3431 97.7393 61.2679 97.6266 61.2679C97.5514 61.2679 97.4762 61.3431 97.4386 61.4558C97.4386 61.4934 97.4386 61.4934 97.4386 61.531L97.5138 62.0948L97.3635 62.1324L97.2883 61.6062C97.2507 61.4559 97.1755 61.3807 97.0628 61.3807C96.95 61.3807 96.9124 61.4934 96.8748 61.5686C96.8748 61.6062 96.8748 61.6062 96.8748 61.6438L96.95 62.2076L96.7996 62.2452L96.6869 61.6062Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M98.3783 61.6062C98.4159 61.8317 98.5663 61.9069 98.7542 61.8693C98.867 61.8693 98.9422 61.8317 99.0173 61.7941L99.0549 61.9069C99.0173 61.9445 98.9046 61.9821 98.7542 62.0196C98.4911 62.0572 98.2656 61.9069 98.228 61.6438C98.1904 61.3807 98.3032 61.1175 98.5663 61.0799C98.867 61.0424 98.9797 61.2679 99.0173 61.4558C99.0173 61.4934 99.0173 61.531 99.0173 61.531L98.3783 61.6062ZM98.8294 61.4182C98.8294 61.3055 98.7542 61.1551 98.5663 61.1927C98.4159 61.2303 98.3408 61.3807 98.3408 61.4934L98.8294 61.4182Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M103.039 61.1552C103.114 61.1927 103.227 61.2303 103.34 61.1927C103.49 61.1551 103.603 61.08 103.565 60.9296C103.565 60.8169 103.452 60.7417 103.302 60.7041C103.077 60.6665 102.926 60.5913 102.926 60.4034C102.889 60.2155 103.039 60.0275 103.302 59.9899C103.415 59.9523 103.528 59.9899 103.603 60.0275L103.565 60.1779C103.528 60.1779 103.415 60.1403 103.302 60.1403C103.114 60.1779 103.077 60.2906 103.077 60.3658C103.077 60.4786 103.189 60.5162 103.377 60.5913C103.603 60.6289 103.716 60.7417 103.753 60.9296C103.791 61.1176 103.678 61.3055 103.377 61.3431C103.264 61.3431 103.114 61.3431 103.039 61.3055V61.1552Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M103.828 59.8772L103.979 59.8396L104.054 60.4034C104.091 60.3658 104.091 60.2906 104.167 60.2531C104.204 60.2155 104.279 60.1779 104.317 60.1779C104.43 60.1779 104.655 60.2155 104.693 60.5162L104.768 61.0424L104.618 61.08L104.543 60.5538C104.505 60.4034 104.467 60.2906 104.279 60.3282C104.167 60.3282 104.091 60.441 104.091 60.5162C104.091 60.5538 104.091 60.5538 104.091 60.5914L104.167 61.1552L104.016 61.1927L103.828 59.8772Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M105.069 59.8772C105.069 59.9147 105.031 59.9899 104.994 59.9899C104.918 59.9899 104.881 59.9523 104.881 59.9147C104.881 59.8396 104.918 59.802 104.956 59.802C104.994 59.7644 105.069 59.802 105.069 59.8772ZM105.069 61.08L104.918 60.1779L105.069 60.1403L105.219 61.0424L105.069 61.08Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M105.407 60.4034C105.407 60.2906 105.369 60.1779 105.369 60.1027L105.52 60.0651L105.557 60.2155C105.595 60.1027 105.708 60.0275 105.858 59.9899C106.084 59.9523 106.271 60.1027 106.309 60.4034C106.347 60.7417 106.196 60.9296 105.971 60.9672C105.858 60.9672 105.745 60.9296 105.67 60.8544L105.745 61.3431L105.595 61.3807L105.407 60.4034ZM105.595 60.5913C105.595 60.6289 105.595 60.6289 105.595 60.6665C105.632 60.7793 105.745 60.8544 105.858 60.8169C106.046 60.7793 106.121 60.6289 106.084 60.441C106.046 60.253 105.933 60.1027 105.745 60.1403C105.632 60.1403 105.557 60.253 105.52 60.3658C105.52 60.4034 105.52 60.4034 105.52 60.441L105.595 60.5913Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M106.798 59.5389C106.91 59.5013 107.023 59.4637 107.136 59.4637C107.361 59.4261 107.549 59.4637 107.662 59.5389C107.775 59.6141 107.888 59.7644 107.925 59.9524C107.963 60.1403 107.925 60.3282 107.813 60.4786C107.7 60.6289 107.512 60.7041 107.286 60.7417C107.174 60.7417 107.061 60.7793 106.986 60.7793L106.798 59.5389ZM107.098 60.6289C107.136 60.6289 107.211 60.6289 107.249 60.6289C107.587 60.5913 107.775 60.3658 107.7 60.0275C107.662 59.7268 107.474 59.5765 107.098 59.6141C107.023 59.6141 106.948 59.6517 106.91 59.6517L107.098 60.6289Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M108.715 60.5161L108.677 60.4033C108.639 60.4785 108.564 60.5537 108.414 60.5912C108.226 60.6288 108.113 60.5161 108.113 60.3657C108.076 60.1402 108.264 59.9898 108.602 59.9523V59.9147C108.602 59.8395 108.564 59.6891 108.376 59.7267C108.301 59.7267 108.226 59.7643 108.151 59.8395L108.113 59.7267C108.188 59.6516 108.301 59.614 108.414 59.614C108.677 59.5764 108.79 59.7643 108.827 59.9523L108.865 60.2905C108.865 60.3657 108.903 60.4409 108.903 60.5161H108.715ZM108.602 60.065C108.414 60.1026 108.226 60.1402 108.264 60.3281C108.264 60.4409 108.376 60.4785 108.452 60.4785C108.564 60.4785 108.639 60.3657 108.639 60.2905V60.253L108.602 60.065Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M109.128 59.2758L109.166 59.5389L109.391 59.5013V59.614L109.166 59.6516L109.241 60.1403C109.241 60.253 109.316 60.3282 109.391 60.2906C109.429 60.2906 109.466 60.2906 109.504 60.253L109.542 60.3658C109.504 60.3658 109.466 60.4034 109.391 60.4034C109.316 60.4034 109.241 60.4034 109.203 60.3658C109.166 60.3282 109.128 60.253 109.091 60.1403L109.015 59.6516L108.865 59.6892V59.5765L109.015 59.5389L108.978 59.3133L109.128 59.2758Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M109.729 59.9524C109.767 60.1779 109.917 60.2531 110.105 60.2155C110.218 60.2155 110.293 60.1779 110.331 60.1403L110.368 60.2531C110.331 60.2907 110.218 60.3282 110.068 60.3658C109.805 60.4034 109.579 60.2531 109.542 59.99C109.504 59.7268 109.617 59.4637 109.88 59.4261C110.181 59.3886 110.293 59.6141 110.331 59.802C110.331 59.8396 110.331 59.8772 110.331 59.8772L109.729 59.9524ZM110.218 59.7644C110.218 59.6517 110.143 59.5013 109.955 59.5389C109.805 59.5765 109.729 59.7268 109.729 59.8396L110.218 59.7644Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M114.052 59.5388C114.127 59.5764 114.24 59.614 114.353 59.5764C114.503 59.5388 114.616 59.4636 114.578 59.3133C114.578 59.2005 114.465 59.1254 114.315 59.0878C114.089 59.0502 113.939 58.975 113.939 58.7871C113.902 58.5991 114.052 58.4112 114.315 58.3736C114.428 58.336 114.541 58.3736 114.616 58.4112L114.578 58.5615C114.541 58.5615 114.428 58.524 114.315 58.524C114.127 58.5615 114.089 58.6743 114.089 58.7495C114.089 58.8622 114.202 58.8998 114.39 58.975C114.616 59.0126 114.728 59.1254 114.766 59.3133C114.804 59.5012 114.691 59.6892 114.39 59.7268C114.277 59.7268 114.127 59.7268 114.052 59.6892V59.5388Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M114.841 58.261L114.992 58.2234L115.067 58.7872C115.104 58.7496 115.104 58.6744 115.18 58.6368C115.217 58.5993 115.292 58.5617 115.33 58.5617C115.443 58.5617 115.668 58.5993 115.706 58.9L115.781 59.4262L115.631 59.4638L115.555 58.9376C115.518 58.7872 115.443 58.6744 115.292 58.712C115.18 58.712 115.104 58.8248 115.104 58.9C115.104 58.9376 115.104 58.9376 115.104 58.9751L115.18 59.539L115.029 59.5765L114.841 58.261Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M116.082 58.2608C116.082 58.2984 116.044 58.3736 116.007 58.3736C115.931 58.3736 115.894 58.336 115.894 58.2984C115.894 58.2232 115.931 58.1856 115.969 58.1856C116.044 58.1481 116.082 58.1856 116.082 58.2608ZM116.082 59.4636L115.931 58.5615L116.082 58.5239L116.232 59.426L116.082 59.4636Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M116.42 58.7872C116.42 58.6744 116.382 58.5617 116.382 58.4865L116.533 58.4489L116.57 58.5992C116.608 58.4865 116.721 58.4113 116.871 58.3737C117.096 58.3361 117.284 58.4865 117.322 58.7872C117.36 59.1255 117.209 59.3134 116.984 59.351C116.871 59.351 116.758 59.3134 116.683 59.2382L116.758 59.7269L116.608 59.7645L116.42 58.7872ZM116.608 58.9751C116.608 59.0127 116.608 59.0127 116.608 59.0503C116.645 59.1631 116.758 59.2382 116.871 59.2006C117.059 59.1631 117.134 59.0127 117.096 58.8248C117.059 58.6368 116.946 58.4865 116.758 58.5241C116.645 58.5241 116.57 58.6368 116.533 58.7496C116.533 58.7872 116.533 58.7872 116.533 58.8248L116.608 58.9751Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M118.187 59.1254L117.585 57.9226L117.773 57.885L118.074 58.4864C118.149 58.6367 118.224 58.7871 118.262 58.9374C118.262 58.7871 118.299 58.6367 118.337 58.4488L118.45 57.8098L118.638 57.7722L118.374 59.0878L118.187 59.1254Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M118.938 57.8474C118.938 57.885 118.901 57.9601 118.863 57.9601C118.788 57.9601 118.75 57.9225 118.75 57.885C118.75 57.8098 118.788 57.7722 118.825 57.7722C118.901 57.7346 118.938 57.7722 118.938 57.8474ZM118.938 59.0502L118.788 58.1481L118.938 58.1105L119.089 59.0126L118.938 59.0502Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M119.878 58.8999L119.84 58.7871C119.803 58.8623 119.728 58.9374 119.577 58.975C119.389 59.0126 119.277 58.8999 119.277 58.7495C119.239 58.524 119.427 58.3736 119.765 58.336V58.2985C119.765 58.2233 119.728 58.0729 119.54 58.1105C119.465 58.1105 119.389 58.1481 119.314 58.2233L119.277 58.1105C119.352 58.0353 119.465 57.9978 119.577 57.9978C119.84 57.9602 119.953 58.1481 119.991 58.336L120.028 58.6743C120.028 58.7495 120.066 58.8247 120.066 58.8999H119.878ZM119.765 58.4488C119.577 58.4864 119.389 58.524 119.427 58.7119C119.427 58.8247 119.54 58.8623 119.615 58.8623C119.728 58.8623 119.803 58.7495 119.803 58.6743V58.6367L119.765 58.4488Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M126.531 56.9078L126.156 56.9453L126.118 56.795L127.058 56.6447L127.095 56.795L126.719 56.8326L126.87 57.9602L126.719 57.9978L126.531 56.9078Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M127.283 57.5091C127.321 57.7347 127.471 57.8098 127.659 57.7722C127.772 57.7722 127.847 57.7347 127.885 57.6971L127.922 57.8098C127.885 57.8474 127.772 57.885 127.622 57.9226C127.358 57.9602 127.133 57.8098 127.095 57.5467C127.058 57.2836 127.17 57.0205 127.434 56.9829C127.734 56.9453 127.847 57.1708 127.885 57.3588C127.885 57.3964 127.885 57.434 127.885 57.434L127.283 57.5091ZM127.734 57.3212C127.734 57.2084 127.659 57.0581 127.471 57.0957C127.321 57.1333 127.246 57.2836 127.246 57.3964L127.734 57.3212Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M128.11 57.2085C128.11 57.0958 128.073 57.0206 128.073 56.9078L128.223 56.8702L128.261 57.0582C128.298 56.9454 128.373 56.8326 128.486 56.8326H128.524L128.561 56.983C128.561 56.983 128.524 56.983 128.486 56.983C128.373 56.983 128.298 57.0958 128.298 57.2461C128.298 57.2837 128.298 57.2837 128.298 57.3213L128.373 57.8099L128.223 57.8475L128.11 57.2085Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M128.712 57.0581C128.712 56.9829 128.674 56.8702 128.674 56.795L128.824 56.7574L128.862 56.9078C128.899 56.8326 128.975 56.7198 129.125 56.6822C129.238 56.6822 129.351 56.7198 129.426 56.8326C129.463 56.795 129.463 56.7198 129.501 56.6822C129.538 56.6446 129.614 56.6071 129.689 56.6071C129.802 56.6071 129.99 56.6446 130.027 56.9453L130.102 57.4716L129.952 57.5092L129.877 56.9829C129.839 56.795 129.764 56.7198 129.651 56.7198C129.576 56.7198 129.501 56.795 129.463 56.9078C129.463 56.9453 129.463 56.9453 129.463 56.9829L129.538 57.5467L129.388 57.5843L129.313 57.0581C129.275 56.9078 129.2 56.8326 129.087 56.8326C128.975 56.8326 128.937 56.9453 128.899 57.0205C128.899 57.0581 128.899 57.0581 128.899 57.0957L128.975 57.6595L128.824 57.6971L128.712 57.0581Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M130.328 57.3212C130.365 57.3588 130.478 57.3588 130.553 57.3588C130.666 57.3588 130.704 57.2836 130.704 57.2084C130.704 57.1333 130.629 57.0957 130.516 57.0581C130.328 57.0205 130.253 56.9453 130.253 56.8326C130.215 56.6822 130.328 56.5319 130.516 56.5319C130.591 56.5319 130.704 56.5319 130.741 56.5694L130.704 56.6822C130.666 56.6822 130.591 56.6446 130.516 56.6446C130.403 56.6446 130.365 56.7198 130.365 56.795C130.365 56.8701 130.441 56.9077 130.553 56.9077C130.704 56.9453 130.816 57.0205 130.816 57.1333C130.854 57.2836 130.741 57.434 130.516 57.4715C130.403 57.4715 130.328 57.4715 130.253 57.434L130.328 57.3212Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M137.92 55.1412C138.033 55.1036 138.146 55.066 138.259 55.066C138.484 55.0284 138.672 55.066 138.785 55.1412C138.898 55.2164 139.01 55.3667 139.048 55.5547C139.085 55.7426 139.048 55.9305 138.935 56.0809C138.822 56.2312 138.634 56.3064 138.409 56.344C138.296 56.344 138.183 56.3816 138.108 56.3816L137.92 55.1412ZM138.259 56.2312C138.296 56.2312 138.371 56.2312 138.409 56.2312C138.747 56.1936 138.935 55.9681 138.86 55.6298C138.822 55.3291 138.634 55.1788 138.259 55.2164C138.183 55.2164 138.108 55.254 138.071 55.254L138.259 56.2312Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M140.1 55.8177C140.1 55.8929 140.138 56.0056 140.138 56.0808L139.988 56.1184L139.95 55.9681C139.912 56.0432 139.837 56.156 139.687 56.1936C139.536 56.2312 139.349 56.156 139.311 55.8553L139.236 55.3291L139.386 55.2915L139.461 55.7801C139.499 55.9681 139.574 56.0432 139.724 56.0432C139.837 56.0432 139.912 55.9305 139.912 55.8553C139.912 55.8177 139.912 55.7801 139.912 55.7801L139.837 55.2163L139.988 55.1787L140.1 55.8177Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M140.439 55.5921C140.476 55.8177 140.627 55.8928 140.777 55.8553C140.89 55.8553 140.965 55.8177 141.04 55.7801L141.078 55.8928C141.04 55.9304 140.927 55.968 140.777 56.0056C140.514 56.0432 140.288 55.8928 140.251 55.6297C140.213 55.3666 140.326 55.1035 140.589 55.0659C140.89 55.0283 141.002 55.2538 141.04 55.4418C141.04 55.4794 141.04 55.517 141.04 55.517L140.439 55.5921ZM140.89 55.4042C140.89 55.2914 140.814 55.1411 140.627 55.1787C140.476 55.2163 140.401 55.3666 140.401 55.4794L140.89 55.4042Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M141.566 54.5772C141.679 54.5396 141.792 54.502 141.905 54.502C142.13 54.4645 142.318 54.5021 142.431 54.5772C142.543 54.6524 142.656 54.8028 142.694 54.9907C142.731 55.1786 142.694 55.3666 142.581 55.5169C142.468 55.6673 142.28 55.7424 142.055 55.78C141.942 55.78 141.829 55.8176 141.754 55.8176L141.566 54.5772ZM141.905 55.7049C141.942 55.7049 142.017 55.7049 142.055 55.7049C142.393 55.6673 142.581 55.4417 142.506 55.1035C142.468 54.8028 142.28 54.6524 141.905 54.69C141.829 54.69 141.754 54.7276 141.717 54.7276L141.905 55.7049Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M143.483 55.5923L143.446 55.4795C143.408 55.5547 143.333 55.6298 143.183 55.6674C142.995 55.705 142.882 55.5923 142.882 55.4419C142.844 55.2164 143.032 55.066 143.37 55.0284C143.37 54.9533 143.333 54.8029 143.145 54.8405C143.07 54.8405 142.957 54.8781 142.919 54.9533L142.882 54.8405C142.957 54.7653 143.07 54.7277 143.183 54.7277C143.446 54.6902 143.558 54.8781 143.596 55.066L143.634 55.4043C143.634 55.4795 143.671 55.5547 143.671 55.6298L143.483 55.5923ZM143.408 55.1412C143.22 55.1788 143.032 55.2164 143.07 55.4043C143.07 55.5171 143.183 55.5547 143.258 55.5547C143.37 55.5547 143.446 55.4419 143.446 55.3667V55.3291L143.408 55.1412Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M143.934 54.3142L143.972 54.5773L144.197 54.5397V54.6525L143.972 54.6901L144.047 55.1787C144.047 55.2915 144.122 55.3667 144.197 55.3291C144.235 55.3291 144.272 55.3291 144.272 55.2915L144.31 55.4043C144.272 55.4043 144.235 55.4418 144.16 55.4418C144.085 55.4418 144.009 55.4418 143.972 55.4043C143.934 55.3667 143.897 55.2915 143.859 55.1787L143.784 54.6901L143.633 54.7277V54.6149L143.784 54.5773L143.746 54.3518L143.934 54.3142Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M144.536 54.9908C144.573 55.2163 144.724 55.2915 144.911 55.2539C145.024 55.2539 145.099 55.2163 145.175 55.1788L145.212 55.2915C145.175 55.3291 145.062 55.3667 144.911 55.4043C144.648 55.4419 144.423 55.2915 144.385 55.0284C144.348 54.7653 144.46 54.5022 144.724 54.4646C145.024 54.427 145.137 54.6525 145.175 54.8405C145.175 54.8781 145.175 54.9156 145.175 54.9156L144.536 54.9908ZM144.987 54.8029C144.987 54.6901 144.911 54.5398 144.724 54.5774C144.573 54.6149 144.498 54.7653 144.498 54.8781L144.987 54.8029Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M88.9062 71.6422C89.019 71.6046 89.1317 71.567 89.2445 71.567C89.47 71.5294 89.6579 71.567 89.7707 71.6422C89.8835 71.7173 89.9962 71.8677 90.0338 72.0556C90.0714 72.2436 90.0338 72.4315 89.9211 72.5819C89.8083 72.7322 89.6204 72.8074 89.3948 72.845C89.2821 72.845 89.1693 72.8826 89.0941 72.8826L88.9062 71.6422ZM89.2069 72.7698C89.2445 72.7698 89.3197 72.7698 89.3572 72.7698C89.6955 72.7322 89.8835 72.5067 89.8083 72.1684C89.7707 71.8677 89.5828 71.7173 89.2069 71.7549C89.1317 71.7549 89.0565 71.7925 89.019 71.7925L89.2069 72.7698Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M90.3721 72.2811C90.4097 72.5066 90.5601 72.5818 90.748 72.5442C90.8608 72.5442 90.9359 72.5066 91.0111 72.469L91.0487 72.5818C91.0111 72.6194 90.8983 72.657 90.748 72.6946C90.4849 72.7322 90.2594 72.5818 90.2218 72.3187C90.1842 72.0556 90.2969 71.7925 90.5601 71.7549C90.8608 71.7173 90.9735 71.9428 91.0111 72.1308C91.0111 72.1683 91.0111 72.2059 91.0111 72.2059L90.3721 72.2811ZM90.8232 72.0932C90.8232 71.9804 90.748 71.8301 90.5601 71.8676C90.4097 71.9052 90.3345 72.0556 90.3345 72.1683L90.8232 72.0932Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M91.2367 72.4314C91.2743 72.469 91.3871 72.469 91.4623 72.469C91.575 72.469 91.6126 72.3938 91.6126 72.3187C91.6126 72.2435 91.5374 72.2059 91.4247 72.1683C91.2367 72.1307 91.1616 72.0556 91.1616 71.9428C91.124 71.7924 91.2367 71.6421 91.4247 71.6421C91.4998 71.6421 91.6126 71.6421 91.6502 71.6797L91.6126 71.7924C91.575 71.7924 91.4998 71.7549 91.4247 71.7549C91.3119 71.7549 91.2743 71.83 91.2743 71.9052C91.2743 71.9804 91.3495 72.018 91.4623 72.018C91.6126 72.0556 91.7254 72.1307 91.7254 72.2435C91.763 72.3938 91.6502 72.5442 91.4247 72.5818C91.3119 72.5818 91.2367 72.5818 91.1616 72.5442L91.2367 72.4314Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M92.6649 72.3563C92.6273 72.3939 92.5521 72.4315 92.4018 72.4315C92.1387 72.4691 91.9131 72.3187 91.8755 72.018C91.838 71.7549 91.9883 71.4918 92.289 71.4542C92.4018 71.4542 92.477 71.4542 92.5145 71.4542V71.6046C92.477 71.6046 92.4018 71.567 92.3266 71.6046C92.1011 71.6422 92.0259 71.7925 92.0635 71.9804C92.1011 72.206 92.2514 72.3187 92.4394 72.2811C92.5145 72.2811 92.5897 72.2436 92.6273 72.206L92.6649 72.3563Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M92.7776 71.7172C92.7776 71.6044 92.7401 71.5292 92.7401 71.4165L92.8904 71.3789L92.928 71.5668C92.9656 71.4541 93.0408 71.3413 93.1535 71.3413H93.1911L93.2287 71.4917C93.2287 71.4917 93.1911 71.4917 93.1535 71.4917C93.0408 71.4917 92.9656 71.6044 92.9656 71.7548C92.9656 71.7924 92.9656 71.7924 92.9656 71.8299L93.0408 72.3186L92.8904 72.3562L92.7776 71.7172Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M93.4918 71.0783C93.4918 71.1159 93.4542 71.1911 93.4167 71.1911C93.3415 71.1911 93.3039 71.1535 93.3039 71.1159C93.3039 71.0407 93.3415 71.0031 93.3791 71.0031C93.4167 70.9656 93.4918 71.0031 93.4918 71.0783ZM93.4542 72.2811L93.3039 71.379L93.4542 71.3414L93.6046 72.2435L93.4542 72.2811Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M93.8302 71.6044C93.8302 71.4917 93.7926 71.3789 93.7926 71.3037L93.943 71.2662L93.9805 71.4165C94.0181 71.3037 94.1309 71.2286 94.2812 71.191C94.5068 71.1534 94.6947 71.3037 94.7323 71.6044C94.7699 71.9427 94.6195 72.1307 94.394 72.1683C94.2812 72.1683 94.1685 72.1307 94.0933 72.0555L94.1685 72.5441L94.0181 72.5817L93.8302 71.6044ZM94.0181 71.7924C94.0181 71.83 94.0181 71.83 94.0181 71.8676C94.0557 71.9803 94.1685 72.0555 94.2812 72.0179C94.4692 71.9803 94.5444 71.83 94.5068 71.642C94.4692 71.4541 94.3564 71.3037 94.2061 71.3413C94.0933 71.3413 94.0181 71.4541 93.9805 71.5669C93.9805 71.6044 93.9805 71.6044 93.9805 71.642L94.0181 71.7924Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M94.9954 70.8528L95.0329 71.1159L95.2585 71.0783V71.1911L95.0329 71.2287L95.1081 71.7173C95.1081 71.8301 95.1833 71.9052 95.2585 71.8677C95.2961 71.8677 95.3336 71.8677 95.3712 71.8301L95.4088 71.9428C95.3712 71.9428 95.3336 71.9804 95.2585 71.9804C95.1833 71.9804 95.1081 71.9804 95.0705 71.9428C95.0329 71.9052 94.9954 71.8301 94.9578 71.7173L94.8826 71.2287L94.7322 71.2662V71.1535L94.8826 71.1159L94.845 70.8904L94.9954 70.8528Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M95.5969 70.7775C95.5969 70.8151 95.5593 70.8903 95.5217 70.8903C95.4465 70.8903 95.4089 70.8527 95.4089 70.8151C95.4089 70.74 95.4465 70.7024 95.4841 70.7024C95.5593 70.6648 95.5969 70.7024 95.5969 70.7775ZM95.5969 71.9428L95.4465 71.0407L95.5969 71.0031L95.7472 71.9052L95.5969 71.9428Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M96.7996 71.3039C96.8371 71.6422 96.6492 71.8301 96.4237 71.8677C96.1606 71.9053 95.9726 71.7549 95.935 71.4542C95.8974 71.1535 96.0478 70.928 96.3109 70.8904C96.5364 70.8528 96.762 71.0408 96.7996 71.3039ZM96.0854 71.4166C96.123 71.6046 96.2357 71.7549 96.4237 71.7173C96.574 71.6797 96.6868 71.5294 96.6492 71.3415C96.6116 71.1911 96.5364 71.0032 96.3109 71.0408C96.123 71.0408 96.0478 71.2663 96.0854 71.4166Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M96.9875 71.0783C96.9875 71.0031 96.95 70.8903 96.95 70.8527L97.1003 70.8152L97.1379 70.9655C97.1755 70.8903 97.2507 70.7776 97.401 70.74C97.5138 70.74 97.7393 70.7776 97.7769 71.0783L97.8521 71.6045L97.7017 71.6421L97.6265 71.1159C97.5889 70.9655 97.5138 70.8528 97.3634 70.8903C97.2507 70.8903 97.1755 71.0031 97.1755 71.0783C97.1755 71.1159 97.1755 71.1159 97.1755 71.1535L97.2507 71.7173L97.1003 71.7549L96.9875 71.0783Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M116.157 69.1238C115.969 69.0862 115.819 69.0862 115.668 69.0486C115.631 69.0486 115.631 69.0486 115.593 69.0486C115.293 69.0862 114.992 68.8983 114.954 68.4848C114.879 68.0714 115.105 67.7707 115.443 67.7331C115.781 67.6955 116.044 67.921 116.119 68.2969C116.157 68.6352 116.044 68.8607 115.856 68.9735C115.969 68.9735 116.119 69.011 116.232 69.011L116.157 69.1238ZM115.894 68.2969C115.856 68.0338 115.706 67.8082 115.405 67.8458C115.142 67.8834 115.029 68.1465 115.067 68.4472C115.105 68.7103 115.293 68.9359 115.556 68.8983C115.819 68.8607 115.932 68.5976 115.894 68.2969Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M117.097 68.5223C117.097 68.5975 117.134 68.7102 117.134 68.7854L116.984 68.823L116.946 68.6726C116.909 68.7478 116.834 68.8606 116.683 68.8982C116.533 68.9358 116.345 68.8606 116.307 68.5599L116.232 68.0336L116.383 67.9961L116.458 68.4847C116.495 68.6726 116.571 68.7478 116.721 68.7478C116.834 68.7478 116.909 68.6351 116.909 68.5599C116.909 68.5223 116.909 68.4847 116.909 68.4847L116.834 67.9209L116.984 67.8833L117.097 68.5223Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M117.924 68.6727L117.886 68.5599C117.848 68.6351 117.773 68.7103 117.623 68.7479C117.435 68.7855 117.322 68.6727 117.322 68.5223C117.285 68.2968 117.473 68.1465 117.811 68.1089V68.0713C117.811 67.9961 117.773 67.8458 117.585 67.8833C117.51 67.8833 117.435 67.9209 117.36 67.9961L117.322 67.8833C117.397 67.8082 117.51 67.7706 117.623 67.7706C117.886 67.733 117.999 67.9209 118.036 68.1089L118.074 68.4472C118.074 68.5223 118.112 68.5975 118.112 68.6727H117.924ZM117.811 68.2216C117.623 68.2592 117.435 68.2968 117.473 68.4848C117.473 68.5975 117.585 68.6351 117.661 68.6351C117.773 68.6351 117.848 68.5223 117.848 68.4472V68.4096L117.811 68.2216Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M118.224 67.9585C118.224 67.8833 118.187 67.7706 118.187 67.6954L118.337 67.6578L118.375 67.8082C118.412 67.733 118.487 67.6202 118.638 67.5826C118.751 67.5826 118.976 67.6202 119.014 67.9209L119.089 68.4472L118.939 68.4847L118.863 67.9585C118.826 67.8082 118.788 67.6954 118.6 67.733C118.487 67.733 118.412 67.8458 118.412 67.9209C118.412 67.9585 118.412 67.9585 118.412 67.9961L118.487 68.5599L118.337 68.5975L118.224 67.9585Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M119.39 67.2444L119.427 67.5075L119.653 67.4699V67.5827L119.427 67.6203L119.502 68.1089C119.502 68.2217 119.578 68.2968 119.653 68.2592C119.69 68.2592 119.728 68.2592 119.766 68.2217L119.803 68.3344C119.766 68.3344 119.728 68.372 119.653 68.372C119.578 68.372 119.502 68.372 119.465 68.3344C119.427 68.2968 119.39 68.2217 119.352 68.1089L119.277 67.6203L119.127 67.6578V67.5451L119.277 67.5075L119.239 67.282L119.39 67.2444Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M119.991 67.1692C119.991 67.2068 119.953 67.2819 119.916 67.2819C119.841 67.2819 119.803 67.2443 119.803 67.2068C119.803 67.1316 119.841 67.094 119.878 67.094C119.916 67.094 119.991 67.1316 119.991 67.1692ZM119.953 68.372L119.803 67.4699L119.953 67.4323L120.104 68.3344L119.953 68.372Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M120.442 67.094L120.48 67.3571L120.705 67.3195V67.4323L120.48 67.4699L120.555 67.9585C120.555 68.0713 120.63 68.1465 120.705 68.1089C120.743 68.1089 120.78 68.1089 120.818 68.0713L120.856 68.184C120.818 68.184 120.78 68.2216 120.705 68.2216C120.63 68.2216 120.555 68.2216 120.517 68.184C120.48 68.1464 120.442 68.0713 120.404 67.9585L120.329 67.4699L120.179 67.5075V67.3947L120.329 67.3571L120.292 67.1316L120.442 67.094Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M120.968 67.282L121.231 67.8082C121.269 67.8834 121.307 67.921 121.307 67.9961C121.307 67.9585 121.307 67.8834 121.344 67.8082L121.457 67.2444L121.645 67.2068L121.495 67.8834C121.419 68.2217 121.382 68.372 121.269 68.4848C121.194 68.5599 121.119 68.5975 121.081 68.6351L121.006 68.4848C121.043 68.4472 121.081 68.4472 121.156 68.372C121.194 68.3344 121.231 68.2592 121.269 68.1841V68.1465V68.1089L120.818 67.3196L120.968 67.282Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M126.343 66.3423L126.456 67.094C126.493 67.3947 126.644 67.4699 126.794 67.4699C126.982 67.4323 127.095 67.3195 127.057 67.0188L126.945 66.2671L127.095 66.2295L127.208 66.9812C127.283 67.3571 127.095 67.5451 126.794 67.5826C126.531 67.6202 126.306 67.5075 126.268 67.094L126.155 66.3423H126.343Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M127.471 66.7932C127.471 66.7181 127.433 66.6053 127.433 66.5301L127.584 66.4925L127.621 66.6429C127.659 66.5677 127.734 66.4549 127.884 66.4174C127.997 66.4174 128.223 66.4549 128.26 66.7556L128.335 67.2819L128.185 67.3195L128.11 66.7932C128.072 66.6429 128.035 66.5301 127.847 66.5677C127.734 66.5677 127.659 66.6805 127.659 66.7556C127.659 66.7932 127.659 66.7932 127.659 66.8308L127.734 67.3946L127.584 67.4322L127.471 66.7932Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M128.636 66.1167C128.636 66.1542 128.598 66.2294 128.561 66.2294C128.486 66.2294 128.448 66.1918 128.448 66.1542C128.448 66.0791 128.486 66.0415 128.523 66.0415C128.561 66.0039 128.598 66.0415 128.636 66.1167ZM128.598 67.2819L128.448 66.3798L128.598 66.3422L128.749 67.2443L128.598 67.2819Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M129.087 66.0415L129.125 66.3046L129.35 66.267V66.3798L129.125 66.4174L129.2 66.906C129.2 67.0188 129.275 67.094 129.35 67.0564C129.388 67.0564 129.425 67.0564 129.463 67.0188L129.501 67.1315C129.463 67.1315 129.425 67.1691 129.35 67.1691C129.275 67.1691 129.2 67.1691 129.162 67.1315C129.125 67.094 129.087 67.0188 129.05 66.906L128.974 66.4174L128.824 66.455V66.3422L128.974 66.3046L128.937 66.0791L129.087 66.0415Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M129.876 65.816C129.952 65.7784 130.064 65.7784 130.177 65.7408C130.327 65.7032 130.478 65.7408 130.553 65.7784C130.628 65.816 130.703 65.9287 130.703 66.0415C130.703 66.1543 130.703 66.267 130.628 66.3422C130.553 66.455 130.44 66.5301 130.252 66.5301C130.215 66.5301 130.177 66.5301 130.102 66.5301L130.177 67.0188L130.027 67.0564L129.876 65.816ZM130.14 66.4174C130.177 66.4174 130.215 66.4174 130.29 66.4174C130.478 66.3798 130.591 66.267 130.553 66.1167C130.515 65.9663 130.403 65.8911 130.215 65.9287C130.14 65.9287 130.102 65.9663 130.064 65.9663L130.14 66.4174Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M130.929 66.3046C130.929 66.1918 130.891 66.1166 130.891 66.0039L131.042 65.9663L131.079 66.1542C131.117 66.0415 131.192 65.9287 131.305 65.9287C131.342 65.9287 131.342 65.9287 131.342 65.9287L131.38 66.0791C131.38 66.0791 131.342 66.0791 131.305 66.0791C131.192 66.0791 131.117 66.1918 131.117 66.3422C131.117 66.3798 131.117 66.3798 131.117 66.4174L131.192 66.906L131.042 66.9436L130.929 66.3046Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M131.681 65.6656C131.681 65.7032 131.643 65.7784 131.605 65.7784C131.53 65.7784 131.493 65.7408 131.493 65.7032C131.493 65.628 131.53 65.5904 131.568 65.5904C131.605 65.5528 131.681 65.5904 131.681 65.6656ZM131.643 66.8684L131.493 65.9663L131.643 65.9287L131.793 66.8308L131.643 66.8684Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M132.733 66.6428C132.695 66.6804 132.62 66.718 132.47 66.718C132.207 66.7556 131.981 66.6052 131.944 66.3045C131.906 66.0414 132.056 65.7783 132.357 65.7407C132.47 65.7407 132.545 65.7407 132.583 65.7407L132.545 65.8911C132.508 65.8911 132.432 65.8535 132.357 65.8911C132.132 65.9287 132.056 66.079 132.094 66.2669C132.132 66.4925 132.282 66.6052 132.47 66.5676C132.545 66.5676 132.62 66.5301 132.658 66.4925L132.733 66.6428Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M132.959 66.2295C132.996 66.455 133.147 66.5302 133.334 66.4926C133.447 66.4926 133.522 66.455 133.598 66.4174L133.635 66.5302C133.598 66.5678 133.485 66.6053 133.334 66.6429C133.071 66.6805 132.846 66.5302 132.808 66.2671C132.771 66.0039 132.883 65.7408 133.147 65.7032C133.447 65.6657 133.56 65.8912 133.598 66.0791C133.598 66.1167 133.598 66.1543 133.598 66.1543L132.959 66.2295ZM133.41 66.0415C133.41 65.9288 133.334 65.7784 133.147 65.816C132.996 65.8536 132.921 66.0039 132.921 66.1167L133.41 66.0415Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M141.416 64.3124L141.04 64.35L141.003 64.1997L141.942 64.0493L141.98 64.1997L141.604 64.2748L141.754 65.4025L141.604 65.4401L141.416 64.3124Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M142.882 64.7636C142.919 65.1019 142.731 65.2898 142.506 65.3274C142.243 65.365 142.055 65.2146 142.017 64.9139C141.98 64.6132 142.13 64.3877 142.393 64.3501C142.619 64.3125 142.844 64.5005 142.882 64.7636ZM142.168 64.8764C142.205 65.0643 142.318 65.2146 142.506 65.1771C142.656 65.1395 142.769 64.9891 142.731 64.8012C142.694 64.6508 142.619 64.4629 142.393 64.5005C142.168 64.5005 142.13 64.726 142.168 64.8764Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M143.183 64.0117L143.22 64.2748L143.446 64.2372V64.35L143.22 64.3876L143.295 64.8762C143.295 64.989 143.371 65.0642 143.446 65.0266C143.483 65.0266 143.521 65.0266 143.558 64.989L143.596 65.1018C143.558 65.1018 143.521 65.1393 143.446 65.1393C143.371 65.1393 143.295 65.1393 143.258 65.1018C143.22 65.0642 143.183 64.989 143.145 64.8762L143.07 64.3876L142.919 64.4252V64.3124L143.07 64.2748L143.032 64.0493L143.183 64.0117Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M144.273 65.0266L144.235 64.9138C144.197 64.989 144.122 65.0642 143.972 65.1017C143.784 65.1393 143.671 65.0266 143.671 64.8762C143.634 64.6507 143.822 64.5003 144.16 64.4628V64.4252C144.16 64.35 144.122 64.1996 143.934 64.2372C143.859 64.2372 143.784 64.2748 143.709 64.35L143.671 64.2372C143.746 64.1621 143.859 64.1245 143.972 64.1245C144.235 64.0869 144.348 64.2748 144.385 64.4628L144.423 64.801C144.423 64.8762 144.461 64.9514 144.461 65.0266H144.273ZM144.197 64.5755C144.01 64.6131 143.822 64.6507 143.859 64.8386C143.859 64.9514 143.972 64.989 144.047 64.989C144.16 64.989 144.235 64.8762 144.235 64.801V64.7635L144.197 64.5755Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M144.461 63.636L144.611 63.5984L144.799 64.914L144.648 64.9515L144.461 63.636Z",
    fill: "#58595B"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    opacity: 0.2,
    d: "M196.181 47.2855L196.82 47.2479L199 47.1352L198.887 44.9551L197.722 24.9209L197.609 23.0791L197.496 20.899L195.316 21.0118L194.677 21.0494L152.579 23.4926L152.203 23.1919L150.549 21.7636L149.121 23.4174L148.858 23.7181L148.031 23.7557L147.392 23.7933L145.212 23.9061L145.325 26.0861L145.4 27.7024L135.214 39.4673L134.8 39.9559L133.372 41.6098L135.026 43.0381L135.514 43.4516L170.884 73.9727L171.373 74.3862L173.027 75.8145L174.455 74.1606L187.573 58.9753L188.776 57.5845L190.204 55.9307L188.551 54.5023L188.062 54.0889L181.108 48.15L196.181 47.2855C196.143 47.2855 196.143 47.2855 196.181 47.2855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M195.805 46.8344L196.482 46.7968L198.662 46.684L198.549 44.5039L197.384 24.4697L197.271 22.628L197.158 20.4479L194.978 20.5606L194.339 20.5982L147.693 23.3045L147.054 23.3421L144.874 23.4549L144.987 25.635L145.099 27.7023L146.189 46.7968L146.227 47.4358L146.34 49.6158L148.52 49.5031L149.159 49.4655L195.805 46.8344Z",
    fill: "url(#paint1_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M149.008 47.6238L147.73 25.2216L194.414 22.5153L195.73 44.9175L149.008 47.6238Z",
    fill: "url(#paint2_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M193.475 23.5677L194.64 43.9401L149.986 46.5337L148.821 26.1612L193.475 23.5677ZM195.392 21.4252L193.362 21.5379L148.67 24.1315L146.64 24.2442L146.753 26.274L147.918 46.6464L148.031 48.6762L150.061 48.5634L194.715 45.9699L196.745 45.8571L196.632 43.8274L195.467 23.4549L195.392 21.4252Z",
    fill: "url(#paint3_linear_58_978)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M152.166 27.9278C152.278 30.1455 151.226 31.9873 149.76 32.0625C148.294 32.1377 147.016 30.4462 146.903 28.2285C146.791 26.0109 147.843 24.1691 149.309 24.0939C150.737 24.0187 152.015 25.7478 152.166 27.9278Z",
    fill: "url(#paint4_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M195.617 25.184C195.73 27.2513 194.64 28.9803 193.174 29.0931C191.708 29.1683 190.43 27.552 190.317 25.4847C190.204 23.4174 191.295 21.6883 192.723 21.5756C194.189 21.5004 195.467 23.1167 195.617 25.184Z",
    fill: "url(#paint5_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M196.632 43.226C196.707 44.6919 195.617 45.9323 194.151 46.0075C192.685 46.0827 191.445 44.9926 191.37 43.5267C191.294 42.0608 192.384 40.8204 193.85 40.7452C195.316 40.6701 196.557 41.7601 196.632 43.226Z",
    fill: "url(#paint6_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M153.181 45.7443C153.256 47.2102 152.166 48.4506 150.7 48.5258C149.234 48.601 147.994 47.5109 147.918 46.045C147.843 44.5791 148.933 43.3387 150.399 43.2636C151.865 43.1884 153.106 44.2784 153.181 45.7443Z",
    fill: "url(#paint7_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M177.8 34.6936C178.101 39.9558 175.62 44.3912 172.275 44.5791C168.93 44.767 165.96 40.67 165.66 35.4077C165.359 30.1455 167.84 25.7101 171.185 25.5222C174.53 25.3343 177.5 29.4313 177.8 34.6936Z",
    fill: "url(#paint8_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M171.523 43.2636L171.411 41.2714C170.245 41.309 169.043 41.0459 168.328 40.5573L168.742 39.2041C169.494 39.6551 170.546 39.9559 171.636 39.8807C173.064 39.8055 173.967 38.941 173.891 37.8134C173.816 36.7233 173.027 36.0843 171.523 35.5957C169.456 34.9191 168.14 34.0922 168.065 32.3632C167.953 30.7093 169.08 29.3937 170.884 28.9803L170.772 26.9881L172.012 26.913L172.125 28.8299C173.328 28.7923 174.154 29.0555 174.756 29.3937L174.342 30.7469C173.929 30.5214 173.064 30.1455 171.786 30.2207C170.245 30.2958 169.719 31.2731 169.794 32.0625C169.87 33.0773 170.621 33.566 172.388 34.1674C174.493 34.8815 175.583 35.8588 175.658 37.6254C175.733 39.2041 174.756 40.7076 172.726 41.1962L172.839 43.2636H171.523Z",
    fill: "url(#paint9_linear_58_978)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M180.582 44.1657L164.044 45.143L163.968 43.6019L180.507 42.6246L180.582 44.1657Z",
    fill: "url(#paint10_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M159.834 35.7837C159.909 36.7609 159.12 37.6255 158.142 37.663C157.165 37.7382 156.3 36.9489 156.263 35.9716C156.188 34.9943 156.977 34.1298 157.954 34.0922C158.894 34.017 159.759 34.7688 159.834 35.7837Z",
    fill: "url(#paint11_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M157.24 38.941C155.887 38.6027 154.947 37.4375 154.834 36.0467C154.797 35.1822 155.06 34.3929 155.624 33.7539C156.188 33.1149 156.977 32.739 157.804 32.7014C158.142 32.7014 158.443 32.7014 158.781 32.7766C160.134 33.1149 161.074 34.2801 161.187 35.6708C161.3 37.4375 159.946 38.941 158.217 39.0161C157.879 39.0537 157.541 39.0537 157.24 38.941ZM158.668 33.3404C158.405 33.2652 158.142 33.2652 157.879 33.2652C157.165 33.3028 156.526 33.6035 156.075 34.1297C155.624 34.656 155.361 35.3325 155.398 36.0091C155.473 37.1743 156.263 38.114 157.353 38.4147C157.616 38.4899 157.879 38.4899 158.142 38.4899C159.57 38.4147 160.698 37.1743 160.623 35.7084C160.585 34.5808 159.796 33.6035 158.668 33.3404Z",
    fill: "#038A75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M187.085 34.1674C187.16 35.1447 186.371 36.0092 185.393 36.0468C184.416 36.122 183.552 35.3326 183.514 34.3553C183.439 33.3781 184.228 32.5135 185.205 32.476C186.183 32.4384 187.047 33.1901 187.085 34.1674Z",
    fill: "url(#paint12_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M184.529 37.3623C183.176 37.024 182.236 35.8588 182.123 34.4681C182.01 32.7015 183.364 31.198 185.093 31.1228C185.431 31.0852 185.732 31.1228 186.07 31.198C187.423 31.5362 188.363 32.7015 188.475 34.0922C188.588 35.8588 187.235 37.3623 185.506 37.4375C185.168 37.4751 184.829 37.4375 184.529 37.3623ZM185.957 31.7242C185.694 31.649 185.431 31.649 185.168 31.649C183.739 31.7242 182.612 32.9646 182.687 34.4305C182.762 35.5957 183.551 36.5354 184.679 36.8361C184.942 36.9113 185.205 36.9113 185.468 36.9113C186.897 36.8361 188.024 35.5957 187.949 34.1298C187.874 32.9646 187.085 32.0249 185.957 31.7242Z",
    fill: "#038A75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M160.134 29.8824L154.872 30.2207L154.91 30.8597L160.172 30.559L160.134 29.8824Z",
    fill: "url(#paint13_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M187.573 28.3037L182.349 28.6044L182.386 29.2434L187.611 28.9427L187.573 28.3037Z",
    fill: "url(#paint14_linear_58_978)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M170.509 73.5592C170.509 73.5592 170.509 73.5968 170.509 73.5592C170.509 73.5968 170.509 73.5968 170.509 73.5592L170.997 73.9726L172.651 75.401L174.079 73.7471L187.197 58.5617L188.4 57.171L189.829 55.5171L188.175 54.0888L187.686 53.6753L152.316 23.1542L151.827 22.7408L150.174 21.3124L148.745 22.9663L147.392 24.545L134.875 39.0162L134.462 39.5048L133.034 41.1587L134.688 42.587L135.176 43.0005L170.509 73.5592Z",
    fill: "url(#paint15_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M136.379 41.5722L151.038 24.5826L186.446 55.1413L171.786 72.1309L136.379 41.5722Z",
    fill: "url(#paint16_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M185.017 55.2541L171.674 70.7026L137.807 41.4594L151.151 26.011L185.017 55.2541ZM187.874 55.0661L186.333 53.7506L152.504 24.4699L150.963 23.1543L149.647 24.6954L136.266 40.1439L134.951 41.685L136.492 43.0005L170.358 72.2437L171.899 73.5592L173.215 72.0181L186.558 56.5696L187.874 55.0661Z",
    fill: "url(#paint17_linear_58_978)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M152.354 29.6193C150.925 31.2732 148.858 31.8746 147.73 30.8973C146.64 29.9576 146.903 27.8151 148.332 26.1613C149.76 24.5074 151.827 23.906 152.955 24.8833C154.045 25.823 153.782 27.9655 152.354 29.6193Z",
    fill: "url(#paint18_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M185.431 57.8851C184.077 59.4638 182.085 59.9525 180.995 58.9752C179.905 58.0355 180.093 55.9682 181.446 54.3895C182.8 52.8108 184.792 52.3222 185.882 53.2619C187.009 54.2767 186.784 56.3065 185.431 57.8851Z",
    fill: "url(#paint19_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M173.628 71.567C172.688 72.6571 170.997 72.8074 169.907 71.8302C168.817 70.8905 168.667 69.199 169.644 68.109C170.584 67.019 172.275 66.8686 173.365 67.8459C174.455 68.7856 174.568 70.477 173.628 71.567Z",
    fill: "url(#paint20_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M140.664 43.1132C139.724 44.2032 138.033 44.3536 136.943 43.3763C135.853 42.4366 135.702 40.7452 136.68 39.6551C137.619 38.5651 139.311 38.4147 140.401 39.392C141.491 40.3693 141.641 42.0232 140.664 43.1132Z",
    fill: "url(#paint21_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M166.035 52.3223C162.577 56.3066 157.729 57.7725 155.173 55.5924C152.617 53.4123 153.368 48.3756 156.826 44.3913C160.285 40.407 165.133 38.9411 167.689 41.1212C170.208 43.3389 169.456 48.338 166.035 52.3223Z",
    fill: "url(#paint22_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M155.549 54.0889L156.864 52.5854C156 51.8336 155.323 50.7812 155.135 49.9543L156.375 49.2401C156.601 50.067 157.127 51.0443 157.992 51.7585C159.044 52.6981 160.322 52.6981 161.074 51.8336C161.788 51.0067 161.638 49.9918 160.924 48.5635C159.909 46.6465 159.57 45.143 160.698 43.8275C161.788 42.5871 163.48 42.3992 165.058 43.3764L166.374 41.8729L167.313 42.6623L166.035 44.1282C166.9 44.9551 167.313 45.7069 167.539 46.3458L166.299 47.0224C166.148 46.5714 165.81 45.7069 164.833 44.8799C163.667 43.8651 162.653 44.2034 162.126 44.8048C161.45 45.5941 161.675 46.4586 162.502 48.15C163.517 50.1046 163.63 51.5705 162.465 52.9237C161.45 54.1265 159.646 54.5023 157.879 53.4123L156.526 54.991L155.549 54.0889Z",
    fill: "url(#paint23_linear_58_978)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M161.45 61.0802L148.896 50.2549L149.91 49.0897L162.465 59.9149L161.45 61.0802Z",
    fill: "url(#paint24_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M152.391 40.5949C151.752 41.3466 150.625 41.4218 149.873 40.7828C149.121 40.1438 149.046 39.0162 149.685 38.2644C150.324 37.5127 151.452 37.4375 152.203 38.0765C152.955 38.6779 153.03 39.8431 152.391 40.5949Z",
    fill: "url(#paint25_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M148.294 41.0836C147.58 39.9184 147.693 38.4149 148.595 37.3249C149.159 36.6859 149.91 36.31 150.775 36.2348C151.64 36.1596 152.429 36.4603 153.068 36.9866C153.331 37.2121 153.519 37.4376 153.707 37.7383C154.421 38.9411 154.308 40.4446 153.406 41.4971C152.278 42.8126 150.249 42.963 148.933 41.8354C148.708 41.6098 148.482 41.3467 148.294 41.0836ZM153.256 38.039C153.105 37.8135 152.955 37.588 152.73 37.4376C152.203 36.9866 151.527 36.761 150.813 36.7986C150.098 36.8362 149.459 37.1745 149.008 37.7007C148.257 38.5652 148.144 39.8056 148.745 40.7829C148.896 41.0084 149.046 41.234 149.271 41.3843C150.362 42.324 152.015 42.2112 152.955 41.1212C153.744 40.2567 153.857 39.0163 153.256 38.039Z",
    fill: "#038A75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M173.064 58.449C172.425 59.2008 171.298 59.2759 170.546 58.6369C169.794 57.9979 169.719 56.8703 170.358 56.1186C170.997 55.3668 172.125 55.2916 172.876 55.9306C173.628 56.532 173.703 57.6972 173.064 58.449Z",
    fill: "url(#paint26_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M169.005 58.9376C168.291 57.7348 168.403 56.2313 169.306 55.1788C170.433 53.8633 172.463 53.7129 173.779 54.8406C174.042 55.0661 174.23 55.2916 174.418 55.5923C175.132 56.7951 175.019 58.2986 174.117 59.3511C172.989 60.6666 170.959 60.817 169.644 59.6893C169.381 59.4638 169.155 59.2007 169.005 58.9376ZM173.929 55.893C173.779 55.6675 173.628 55.442 173.403 55.2916C172.313 54.3519 170.659 54.4647 169.719 55.5547C168.967 56.4192 168.855 57.6596 169.456 58.6369C169.606 58.8624 169.757 59.0879 169.982 59.2383C171.072 60.178 172.726 60.0652 173.666 58.9752C174.455 58.1107 174.53 56.8703 173.929 55.893Z",
    fill: "#038A75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M156.676 36.5731L152.692 33.1526L152.279 33.6412L156.263 37.0617L156.676 36.5731Z",
    fill: "url(#paint27_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M177.5 54.5399L173.553 51.1194L173.102 51.608L177.086 55.0285L177.5 54.5399Z",
    fill: "url(#paint28_linear_58_978)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M179.116 61.7191C180.356 63.1474 180.206 65.3651 178.778 66.6055C177.349 67.8458 175.132 67.6955 173.891 66.2672C172.651 64.8388 172.801 62.6212 174.23 61.3808C175.658 60.1028 177.838 60.2532 179.116 61.7191Z",
    fill: "#FFDB7A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M178.891 66.7558C177.349 68.0713 175.019 67.921 173.703 66.3799C172.388 64.8388 172.538 62.5084 174.079 61.1928C175.62 59.8772 177.951 60.0276 179.266 61.5687C180.582 63.1098 180.432 65.4026 178.891 66.7558ZM174.342 61.5311C172.989 62.6963 172.839 64.7636 174.042 66.1168C175.207 67.4699 177.274 67.6203 178.627 66.4175C179.981 65.2523 180.131 63.1849 178.928 61.8318C177.763 60.4786 175.696 60.3283 174.342 61.5311Z",
    fill: "#C69E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M177.951 63.9367C178.289 64.3126 178.289 64.7261 177.951 65.1395L178.327 65.553L177.988 65.8537L177.612 65.4402C177.349 65.6282 177.124 65.7409 176.861 65.7409C176.635 65.7409 176.372 65.5906 176.147 65.3275L175.996 65.1395L176.598 64.6133L176.786 64.8388C177.011 65.0644 177.199 65.1395 177.349 64.9892C177.425 64.914 177.462 64.8388 177.462 64.7637C177.462 64.6885 177.425 64.6133 177.312 64.5005C177.161 64.3126 176.898 64.2374 176.56 64.275C176.56 64.275 176.485 64.275 176.297 64.3126C176.147 64.3502 176.071 64.3502 176.034 64.3502C175.545 64.3878 175.207 64.275 174.981 64.0119C174.605 63.5984 174.681 63.1474 175.169 62.6963L174.831 62.2829L175.169 61.9822L175.545 62.3956C175.733 62.2829 175.883 62.2453 176.071 62.2453C176.297 62.2453 176.522 62.3956 176.786 62.6588L176.898 62.8091L176.335 63.2977L176.184 63.1098C176.071 62.997 175.996 62.9219 175.883 62.8843C175.808 62.8467 175.696 62.8843 175.62 62.9595C175.545 63.0346 175.508 63.1098 175.47 63.185C175.47 63.2602 175.508 63.3353 175.583 63.4481C175.696 63.5984 175.921 63.636 176.184 63.636L176.71 63.5609C177.274 63.5233 177.688 63.636 177.951 63.9367Z",
    fill: "#C69E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M187.235 61.8318C188.438 63.3353 188.175 65.5154 186.671 66.7182C185.168 67.8834 182.988 67.6579 181.785 66.1544C180.582 64.6509 180.845 62.4708 182.349 61.268C183.89 60.0652 186.07 60.3283 187.235 61.8318Z",
    fill: "#FFDB7A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M186.784 66.8687C185.205 68.1091 182.875 67.8459 181.634 66.2673C180.394 64.6886 180.657 62.3582 182.236 61.1178C183.815 59.8774 186.145 60.1405 187.385 61.7192C188.663 63.2978 188.4 65.6283 186.784 66.8687ZM182.499 61.4185C181.071 62.5461 180.845 64.5758 181.935 66.0042C183.063 67.4325 185.093 67.658 186.521 66.568C187.949 65.4403 188.175 63.4106 187.085 61.9823C185.995 60.554 183.927 60.2908 182.499 61.4185Z",
    fill: "#C69E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M185.995 64.0119C186.333 64.4254 186.295 64.8012 185.92 65.2147L186.258 65.6658L185.882 65.9289L185.544 65.5154C185.281 65.7033 185.017 65.7785 184.792 65.7785C184.566 65.7785 184.341 65.5906 184.115 65.3275L183.965 65.1395L184.566 64.6509L184.754 64.8764C184.942 65.1395 185.13 65.1771 185.318 65.0643C185.393 64.9892 185.469 64.914 185.469 64.8388C185.469 64.7636 185.431 64.6885 185.356 64.5757C185.205 64.3878 184.942 64.3126 184.604 64.3126C184.604 64.3126 184.529 64.3126 184.341 64.3126C184.191 64.3126 184.115 64.3126 184.078 64.3126C183.589 64.3502 183.251 64.1998 183.025 63.9367C182.687 63.4857 182.762 63.0722 183.251 62.6212L182.913 62.2077L183.288 61.9446L183.627 62.358C183.815 62.2453 183.965 62.2077 184.153 62.2077C184.378 62.2077 184.604 62.3956 184.83 62.6587L184.942 62.8091L184.341 63.2601L184.191 63.0722C184.078 62.9594 184.003 62.8467 183.927 62.8467C183.852 62.8091 183.74 62.8467 183.664 62.8843C183.589 62.9594 183.514 63.0346 183.514 63.1098C183.514 63.185 183.552 63.2601 183.589 63.3729C183.702 63.5233 183.89 63.5984 184.191 63.5984L184.717 63.5608C185.356 63.5608 185.732 63.6736 185.995 64.0119Z",
    fill: "#C69E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M172.049 75.6265C170.358 76.491 168.253 75.852 167.389 74.123C166.524 72.4316 167.163 70.3267 168.892 69.4621C170.584 68.5976 172.688 69.2366 173.553 70.9656C174.417 72.6571 173.778 74.762 172.049 75.6265Z",
    fill: "#FFDB7A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M167.201 74.2358C166.261 72.4316 166.975 70.214 168.779 69.2743C170.584 68.3346 172.801 69.0487 173.741 70.8529C174.681 72.6571 173.967 74.8748 172.162 75.8145C170.358 76.7542 168.14 76.04 167.201 74.2358ZM173.365 71.0785C172.538 69.4998 170.584 68.8608 168.967 69.6877C167.389 70.5147 166.75 72.4692 167.577 74.0855C168.404 75.6642 170.358 76.3031 171.974 75.4762C173.553 74.6493 174.192 72.6572 173.365 71.0785Z",
    fill: "#C69E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M170.17 74.0102C169.719 74.2357 169.306 74.1605 169.005 73.7095L168.516 73.9726L168.291 73.5591L168.779 73.296C168.629 72.9953 168.591 72.7322 168.667 72.5067C168.742 72.2812 168.93 72.0932 169.23 71.9053L169.418 71.7925L169.794 72.5067L169.531 72.657C169.23 72.8074 169.155 72.9577 169.268 73.1457C169.306 73.2584 169.381 73.296 169.456 73.3336C169.531 73.3712 169.644 73.3336 169.757 73.2584C169.982 73.1457 170.095 72.9202 170.133 72.5819C170.133 72.5819 170.133 72.5067 170.17 72.3188C170.17 72.1684 170.208 72.0932 170.208 72.0556C170.283 71.567 170.471 71.2663 170.772 71.116C171.26 70.8528 171.674 71.0408 172.012 71.6046L172.463 71.3791L172.689 71.7925L172.2 72.0556C172.275 72.2436 172.275 72.4315 172.237 72.5819C172.162 72.8074 171.974 72.9953 171.674 73.1833L171.486 73.2584L171.147 72.5819L171.373 72.4691C171.523 72.3939 171.598 72.3188 171.674 72.2436C171.711 72.1684 171.711 72.0932 171.674 71.9805C171.636 71.8677 171.561 71.8301 171.486 71.7925C171.411 71.7549 171.335 71.7925 171.223 71.8301C171.035 71.9053 170.959 72.0932 170.922 72.3563L170.847 72.8826C170.734 73.4464 170.508 73.8223 170.17 74.0102Z",
    fill: "#C69E4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M173.741 136.669L171.749 133.925L170.96 135.729L172.952 138.435L173.741 136.669Z",
    fill: "#CAC9C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M173.741 136.669L171.749 133.925L170.96 135.729L172.952 138.435L173.741 136.669Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M173.591 136.443L171.637 133.737L170.81 135.503L172.802 138.247L173.591 136.443Z",
    fill: "#8A8786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M173.591 136.443L171.637 133.737L170.81 135.503L172.802 138.247L173.591 136.443Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M165.547 125.28C165.171 125.355 164.683 125.129 164.382 124.641C163.743 123.739 164.307 123.175 164.645 122.912L174.606 137.345L174.117 137.684L165.547 125.28Z",
    fill: "url(#paint29_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M165.547 125.28C165.171 125.355 164.683 125.129 164.382 124.641C163.743 123.739 164.307 123.175 164.645 122.912L174.606 137.345L174.117 137.684L165.547 125.28Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M173.666 136.556L171.674 133.812L170.885 135.616L172.877 138.36L173.666 136.556Z",
    fill: "#94918F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M173.666 136.556L171.674 133.812L170.885 135.616L172.877 138.36L173.666 136.556Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M165.397 125.392C165.021 125.468 164.532 125.242 164.232 124.753C163.593 123.851 164.156 123.288 164.495 123.024L174.455 137.458L173.967 137.796L165.397 125.392Z",
    fill: "url(#paint30_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M165.397 125.392C165.021 125.468 164.532 125.242 164.232 124.753C163.593 123.851 164.156 123.288 164.495 123.024L174.455 137.458L173.967 137.796L165.397 125.392Z",
    fill: "url(#paint31_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M165.397 125.392C165.021 125.468 164.532 125.242 164.232 124.753C163.593 123.851 164.156 123.288 164.495 123.024L174.455 137.458L173.967 137.796L165.397 125.392Z",
    fill: "url(#paint32_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M165.397 125.392C165.021 125.468 164.532 125.242 164.232 124.753C163.593 123.851 164.156 123.288 164.495 123.024L174.455 137.458L173.967 137.796L165.397 125.392Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M165.472 125.355C165.096 125.43 164.608 125.204 164.307 124.716C163.668 123.814 164.232 123.25 164.57 122.987L174.531 137.42L174.042 137.759L165.472 125.355Z",
    fill: "url(#paint33_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M165.472 125.355C165.096 125.43 164.608 125.204 164.307 124.716C163.668 123.814 164.232 123.25 164.57 122.987L174.531 137.42L174.042 137.759L165.472 125.355Z",
    fill: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M144.085 98.9308C144.047 98.9684 143.972 98.9308 143.934 98.8556C143.897 98.7805 143.897 98.7053 143.934 98.7053C143.972 98.6677 144.047 98.7053 144.085 98.7805C144.122 98.8181 144.122 98.8932 144.085 98.9308Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M143.897 98.8181C144.047 99.2691 144.348 99.8705 144.498 100.134C144.498 100.134 144.498 100.134 144.536 100.134C144.573 100.096 144.611 100.058 144.686 100.021C144.724 99.9833 144.761 99.9833 144.761 99.9457C144.799 99.9081 144.799 99.9081 144.836 99.9081C144.874 99.8705 144.911 99.8705 144.949 99.833C144.987 99.7954 145.024 99.7954 145.062 99.7578C144.799 99.4195 144.423 99.0436 144.047 98.7429C144.047 98.7429 144.009 98.7429 144.009 98.7805C144.009 98.7805 143.972 98.7805 143.972 98.8181C143.972 98.8181 143.972 98.8181 143.934 98.8181H143.897C143.934 98.8181 143.934 98.8181 143.897 98.8181Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M175.621 143.585C175.733 143.51 175.733 143.284 175.583 143.059C174.906 142.044 174.23 140.991 173.553 139.976C173.516 139.901 173.441 139.826 173.365 139.789C173.29 139.751 173.253 139.751 173.215 139.789C173.177 139.751 173.177 139.751 173.14 139.751C172.914 139.901 172.764 140.052 172.576 140.164C172.388 140.277 172.2 140.39 171.975 140.54C171.975 140.54 171.975 140.578 171.975 140.615C171.937 140.653 171.937 140.691 171.937 140.766C171.937 140.841 171.975 140.916 172.05 140.991C172.764 142.006 173.478 142.984 174.192 143.998C174.343 144.224 174.568 144.299 174.681 144.224L175.621 143.585Z",
    fill: "url(#paint34_linear_58_978)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M175.62 143.585C175.733 143.51 175.733 143.284 175.583 143.059C174.906 142.044 174.23 140.991 173.553 139.976C173.516 139.901 173.44 139.826 173.365 139.789C173.29 139.751 173.252 139.751 173.215 139.789C173.177 139.751 173.177 139.751 173.14 139.751C172.914 139.901 172.764 140.052 172.576 140.164C172.388 140.277 172.2 140.39 171.974 140.54C171.974 140.54 171.974 140.578 171.974 140.615C171.937 140.653 171.937 140.691 171.937 140.766C171.937 140.841 171.974 140.916 172.05 140.991C172.764 142.006 173.478 142.984 174.192 143.998C174.342 144.224 174.568 144.299 174.681 144.224L175.62 143.585Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M174.568 144.374C174.418 144.374 174.23 144.261 174.079 144.074C173.516 143.284 172.952 142.495 172.35 141.705L171.899 141.104C171.824 141.029 171.787 140.916 171.787 140.803C171.787 140.728 171.787 140.653 171.824 140.578C171.824 140.54 171.824 140.54 171.824 140.503V140.465L171.974 140.352C172.162 140.24 172.313 140.127 172.463 140.052C172.576 139.976 172.651 139.901 172.764 139.826L172.989 139.638C173.027 139.601 173.102 139.601 173.14 139.638C173.215 139.638 173.29 139.638 173.328 139.676C173.403 139.713 173.478 139.789 173.553 139.901C174.23 140.916 174.906 141.969 175.583 142.983C175.771 143.284 175.771 143.585 175.583 143.698L174.643 144.337C174.681 144.374 174.643 144.374 174.568 144.374ZM172.05 140.766C172.05 140.841 172.087 140.879 172.125 140.954L172.576 141.555C173.14 142.344 173.704 143.134 174.305 143.923C174.455 144.111 174.568 144.149 174.606 144.111L175.545 143.472C175.583 143.435 175.583 143.284 175.47 143.096C174.794 142.081 174.117 141.029 173.44 140.014C173.44 139.976 173.403 139.976 173.403 139.939L173.666 140.578L173.14 139.864L172.989 139.976C172.877 140.052 172.764 140.127 172.689 140.202H172.651C172.501 140.277 172.35 140.39 172.162 140.503L172.125 140.54L172.238 140.728L172.05 140.766Z",
    fill: "#C9C8C8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M157.24 114.83C154.609 111.109 151.978 107.388 149.159 103.742L146.791 105.396C149.159 109.267 151.752 113.101 154.308 116.86L157.24 114.83Z",
    fill: "#312783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M157.24 114.83C154.609 111.109 151.978 107.388 149.159 103.742L146.791 105.396C149.159 109.267 151.752 113.101 154.308 116.86L157.24 114.83Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    opacity: 0.5,
    d: "M155.962 115.732L156.789 115.169C154.158 111.447 151.527 107.726 148.746 104.08L148.182 104.456L155.962 115.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    opacity: 0.5,
    d: "M155.962 115.732L156.789 115.169C154.158 111.447 151.527 107.726 148.746 104.08L148.182 104.456L155.962 115.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M144.197 99.8329C144.836 101.75 146.114 104.306 146.791 105.396C146.828 105.358 146.828 105.358 146.866 105.321C147.054 105.17 147.279 105.058 147.467 104.907C147.58 104.832 147.73 104.719 147.843 104.644C147.956 104.569 148.069 104.494 148.181 104.419C148.369 104.306 148.52 104.193 148.708 104.08C148.858 103.968 149.008 103.855 149.159 103.78C147.993 102.314 146.415 100.66 144.874 99.3818C144.836 99.4194 144.799 99.457 144.761 99.457C144.723 99.4946 144.648 99.5322 144.611 99.5698C144.573 99.6074 144.535 99.6074 144.535 99.645C144.498 99.6825 144.46 99.6825 144.423 99.7201C144.347 99.7201 144.272 99.7577 144.197 99.8329C144.235 99.8329 144.235 99.8329 144.197 99.8329Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M146.753 105.584L146.678 105.471C146.002 104.343 144.724 101.75 144.085 99.8706L144.047 99.7954L144.423 99.5323C144.46 99.4947 144.498 99.4947 144.498 99.4571L144.836 99.2316L144.912 99.3067C146.377 100.51 147.919 102.126 149.234 103.704L149.309 103.817L148.67 104.268C148.52 104.381 148.37 104.456 148.219 104.569L147.731 104.907C147.655 104.945 147.58 105.02 147.505 105.058L146.753 105.584ZM144.348 99.8706C144.987 101.675 146.152 104.043 146.828 105.208L147.392 104.832C147.467 104.795 147.543 104.719 147.618 104.682L148.106 104.343C148.257 104.231 148.407 104.118 148.558 104.043L148.971 103.742C147.731 102.201 146.227 100.697 144.874 99.5323L144.686 99.645C144.648 99.6826 144.611 99.6826 144.573 99.7202L144.348 99.8706Z",
    fill: "#C9C8C8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M157.917 115.808C157.653 115.432 157.503 115.244 157.24 114.83L154.271 116.86C154.534 117.236 154.646 117.461 154.947 117.837L157.917 115.808Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M154.91 118.025L154.835 117.913C154.571 117.537 154.459 117.349 154.196 116.935L154.12 116.823L154.233 116.747L157.278 114.642L158.105 115.808L154.91 118.025ZM154.459 116.898C154.647 117.198 154.797 117.386 154.985 117.649L157.766 115.732L157.24 114.981L154.459 116.898Z",
    fill: "#C9C8C8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M173.816 139.337C168.667 131.406 163.367 123.551 157.917 115.808L154.947 117.875C160.285 125.693 165.735 133.436 171.336 141.066L173.816 139.337Z",
    fill: "#312783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M173.816 139.337C168.667 131.406 163.367 123.551 157.917 115.808L154.947 117.875C160.285 125.693 165.735 133.436 171.336 141.066L173.816 139.337Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    opacity: 0.5,
    d: "M172.726 140.052L173.328 139.638C168.178 131.707 162.878 123.851 157.428 116.108L156.564 116.71L172.726 140.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    opacity: 0.5,
    d: "M172.726 140.052L173.328 139.638C168.178 131.707 162.878 123.851 157.428 116.108L156.564 116.71L172.726 140.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M174.718 140.691C174.343 140.164 174.192 139.864 173.816 139.337L171.336 141.066C171.711 141.593 171.899 141.856 172.275 142.382L174.718 140.691Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M174.718 140.691L174.794 140.916L172.463 142.532L172.275 142.382L174.718 140.691Z",
    fill: "url(#paint35_linear_58_978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M174.718 140.691L174.794 140.916L172.463 142.532L172.275 142.382L174.718 140.691Z",
    fill: "#9E9E9E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M84.2075 102.163V122.273H124.238V102.163H84.2075ZM121.532 119.829H86.9138V104.682H121.532V119.829Z",
    fill: "#00AA8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M92.8903 107.125H95.559C96.2731 107.125 96.837 107.2 97.2504 107.313C97.6263 107.426 97.927 107.576 98.1149 107.801C98.3029 108.027 98.4532 108.29 98.5284 108.591C98.6036 108.891 98.6412 109.38 98.6412 110.019V110.921C98.6412 111.56 98.566 112.049 98.4532 112.35C98.3029 112.65 98.0773 112.876 97.7015 113.026C97.3256 113.176 96.8745 113.252 96.2731 113.252H95.559V117.386H92.8903V107.125ZM95.559 108.854V111.447C95.6341 111.447 95.7093 111.447 95.7469 111.447C96.01 111.447 96.1604 111.372 96.2731 111.26C96.3859 111.147 96.4235 110.884 96.4235 110.508V109.681C96.4235 109.343 96.3859 109.117 96.2731 109.004C96.1604 108.891 95.8973 108.854 95.559 108.854Z",
    fill: "#00AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M103.678 107.125L105.219 117.349H102.513L102.362 115.507H101.423L101.272 117.349H98.5283L99.8815 107.125H103.678ZM102.249 113.703C102.099 112.537 101.986 111.109 101.836 109.418C101.573 111.372 101.385 112.801 101.31 113.703H102.249Z",
    fill: "#00AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M108.301 107.125V117.349H105.632V107.125H108.301Z",
    fill: "#00AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M109.391 107.125H111.383C112.661 107.125 113.526 107.2 113.977 107.313C114.428 107.426 114.766 107.614 115.029 107.877C115.255 108.14 115.405 108.44 115.48 108.779C115.556 109.117 115.556 109.756 115.556 110.733V114.304C115.556 115.206 115.518 115.845 115.443 116.146C115.368 116.447 115.217 116.71 114.992 116.86C114.766 117.048 114.503 117.161 114.202 117.236C113.902 117.311 113.413 117.349 112.774 117.349H109.429V107.125H109.391ZM112.06 108.854V115.582C112.436 115.582 112.661 115.507 112.774 115.357C112.849 115.206 112.924 114.793 112.924 114.116V110.132C112.924 109.681 112.924 109.38 112.887 109.23C112.849 109.117 112.774 109.004 112.699 108.929C112.549 108.892 112.323 108.854 112.06 108.854Z",
    fill: "#00AA8F"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_978",
    x1: 121.5,
    y1: -4,
    x2: 121.5,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA8F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_978",
    x1: 145.561,
    y1: 36.5908,
    x2: 197.889,
    y2: 33.5351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_978",
    x1: 148.368,
    y1: 36.4276,
    x2: 195.08,
    y2: 33.6999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_978",
    x1: 147.352,
    y1: 36.4858,
    x2: 196.096,
    y2: 33.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_978",
    x1: 146.882,
    y1: 28.2381,
    x2: 152.16,
    y2: 27.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_978",
    x1: 190.321,
    y1: 25.4834,
    x2: 195.601,
    y2: 25.1751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_978",
    x1: 191.365,
    y1: 43.543,
    x2: 196.645,
    y2: 43.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_978",
    x1: 147.912,
    y1: 46.0578,
    x2: 153.193,
    y2: 45.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_58_978",
    x1: 165.652,
    y1: 35.4174,
    x2: 177.796,
    y2: 34.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_58_978",
    x1: 168.01,
    y1: 35.2797,
    x2: 175.435,
    y2: 34.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_58_978",
    x1: 164.007,
    y1: 44.3694,
    x2: 180.554,
    y2: 43.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_58_978",
    x1: 156.23,
    y1: 35.9811,
    x2: 159.816,
    y2: 35.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_58_978",
    x1: 183.516,
    y1: 34.3885,
    x2: 187.102,
    y2: 34.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_58_978",
    x1: 154.896,
    y1: 30.5248,
    x2: 160.137,
    y2: 30.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_58_978",
    x1: 182.367,
    y1: 28.9211,
    x2: 187.607,
    y2: 28.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_58_978",
    x1: 141.574,
    y1: 31.2385,
    x2: 181.258,
    y2: 65.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_58_978",
    x1: 143.702,
    y1: 33.0768,
    x2: 179.128,
    y2: 63.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_58_978",
    x1: 142.931,
    y1: 32.4106,
    x2: 179.898,
    y2: 64.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_58_978",
    x1: 148.337,
    y1: 26.1632,
    x2: 152.341,
    y2: 29.6189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_58_978",
    x1: 181.433,
    y1: 54.4335,
    x2: 185.438,
    y2: 57.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_58_978",
    x1: 169.607,
    y1: 68.1225,
    x2: 173.612,
    y2: 71.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_58_978",
    x1: 136.669,
    y1: 39.6707,
    x2: 140.673,
    y2: 43.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_58_978",
    x1: 156.81,
    y1: 44.3864,
    x2: 166.02,
    y2: 52.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_58_978",
    x1: 158.598,
    y1: 45.9296,
    x2: 164.23,
    y2: 50.7893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_58_978",
    x1: 149.396,
    y1: 49.666,
    x2: 161.945,
    y2: 60.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_58_978",
    x1: 149.655,
    y1: 38.2304,
    x2: 152.374,
    y2: 40.5765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_58_978",
    x1: 170.348,
    y1: 56.0875,
    x2: 173.067,
    y2: 58.4333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_58_978",
    x1: 152.497,
    y1: 33.3853,
    x2: 156.472,
    y2: 36.8153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_58_978",
    x1: 173.331,
    y1: 51.3628,
    x2: 177.305,
    y2: 54.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#326D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_58_978",
    x1: 162.34,
    y1: 125.92,
    x2: 176.976,
    y2: 135.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#E6E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#BDBCBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    stopColor: "#EBE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    stopColor: "#D6D4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_58_978",
    x1: 162.192,
    y1: 126.022,
    x2: 176.827,
    y2: 135.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#C6C0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#6A6664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    stopColor: "#D2CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    stopColor: "#A29E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_58_978",
    x1: 162.192,
    y1: 126.022,
    x2: 176.827,
    y2: 135.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#C6C0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#6A6664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    stopColor: "#D2CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    stopColor: "#A29E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_58_978",
    x1: 162.192,
    y1: 126.022,
    x2: 176.827,
    y2: 135.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#9E9A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#555250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    stopColor: "#A8A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    stopColor: "#827E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_58_978",
    x1: 163.929,
    y1: 123.11,
    x2: 174.522,
    y2: 138.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#C6C0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2435,
    stopColor: "#8A8684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    stopColor: "#D2CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    stopColor: "#A29E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9261,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7F7A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_58_978",
    x1: 173.079,
    y1: 142.545,
    x2: 174.587,
    y2: 141.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#C6C0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#6A6664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#A29E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5879,
    stopColor: "#646261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    stopColor: "#D2CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_58_978",
    x1: 172.341,
    y1: 142.47,
    x2: 174.778,
    y2: 140.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1939,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#D2CECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#A29E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8182,
    stopColor: "#6A6664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#C6C0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBAB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingVariant2);
export default __webpack_public_path__ + "static/media/loading-variant-2.e1c2f56697d3e066de4c81099ed419eb.svg";
export { ForwardRef as ReactComponent };